// Japan Images
import japan1 from "./IntImages/japan/japan1.png";
import japan2 from "./IntImages/japan/japan2.png";
import japan3 from "./IntImages/japan/japan3.png";
import japan4 from "./IntImages/japan/japan4.png";
import japan5 from "./IntImages/japan/japan5.png";
import japan6 from "./IntImages/japan/japan6.png";

// South Korea Images
import sk1 from "./IntImages/sk/sk1.png";
import sk2 from "./IntImages/sk/sk2.png";
import sk3 from "./IntImages/sk/sk3.png";
import sk4 from "./IntImages/sk/sk4.png";
import sk5 from "./IntImages/sk/sk5.png";
import sk6 from "./IntImages/sk/sk6.png";

// Italy Images
import italy1 from "./IntImages/italy/italy1.png";
import italy2 from "./IntImages/italy/italy2.png";
import italy3 from "./IntImages/italy/italy3.png";
import italy4 from "./IntImages/italy/italy4.png";
import italy5 from "./IntImages/italy/italy5.png";
import italy6 from "./IntImages/italy/italy6.png";

//Greece Images
import greece1 from "./IntImages/greece/greece1.png";
import greece2 from "./IntImages/greece/greece2.png";
import greece3 from "./IntImages/greece/greece3.png";
import greece4 from "./IntImages/greece/greece4.png";
import greece5 from "./IntImages/greece/greece5.png";
import greece6 from "./IntImages/greece/greece6.png";

//France Images
import france1 from "./IntImages/france/france1.png";
import france2 from "./IntImages/france/france2.png";
import france3 from "./IntImages/france/france3.png";
import france4 from "./IntImages/france/france4.png";

//Maldives Images
import maldives1 from "./IntImages/maldives/maldives1.png";
import maldives2 from "./IntImages/maldives/maldives2.png";
import maldives3 from "./IntImages/maldives/maldives3.png";
import maldives4 from "./IntImages/maldives/maldives4.png";
import maldives5 from "./IntImages/maldives/maldives5.png";

//Singapore Images
import singapore1 from "./IntImages/singapore/singapore1.png";
import singapore2 from "./IntImages/singapore/singapore2.png";
import singapore3 from "./IntImages/singapore/singapore3.png";
import singapore4 from "./IntImages/singapore/singapore4.png";

//Spain Images
import spain1 from "./IntImages/spain/spain1.png";
import spain2 from "./IntImages/spain/spain2.png";
import spain3 from "./IntImages/spain/spain3.png";
import spain4 from "./IntImages/spain/spain4.png";
import spain5 from "./IntImages/spain/spain5.png";
import spain6 from "./IntImages/spain/spain6.png";

//Switzerland Images
import swiss1 from "./IntImages/swiss/swiss1.png";
import swiss2 from "./IntImages/swiss/swiss2.png";
import swiss3 from "./IntImages/swiss/swiss3.png";
import swiss4 from "./IntImages/swiss/swiss4.png";
import swiss5 from "./IntImages/swiss/swiss5.png";

// Thailand Images
import thailand1 from "./IntImages/thailand/thailand1.png";
import thailand2 from "./IntImages/thailand/thailand2.png";
import thailand3 from "./IntImages/thailand/thailand3.png";
import thailand4 from "./IntImages/thailand/thailand4.png";
import thailand5 from "./IntImages/thailand/thailand5.png";
import thailand6 from "./IntImages/thailand/thailand6.png";

//Thailand Images Phuket & Krabi
import phuket1 from "./IntImages/phuket/phuket1.png";
import phuket2 from "./IntImages/phuket/phuket2.png";
import phuket3 from "./IntImages/phuket/phuket3.png";
import phuket4 from "./IntImages/phuket/phuket4.png";
import phuket5 from "./IntImages/phuket/phuket5.png";
import phuket6 from "./IntImages/phuket/phuket6.png";

// Sri Lanka Images
import lanka1 from "./IntImages/lanka/lanka1.png";
import lanka2 from "./IntImages/lanka/lanka2.png";
import lanka3 from "./IntImages/lanka/lanka3.png";
import lanka4 from "./IntImages/lanka/lanka4.png";
import lanka5 from "./IntImages/lanka/lanka5.png";

//Bali Images
import bali1 from "./IntImages/bali/bali1.png";
import bali2 from "./IntImages/bali/bali2.png";
import bali3 from "./IntImages/bali/bali3.png";
import bali4 from "./IntImages/bali/bali4.png";
import bali5 from "./IntImages/bali/bali5.png";
import bali6 from "./IntImages/bali/bali6.png";

//Vietnam Images
import vietnam1 from "./IntImages/vietnam/vietnam1.png";
import vietnam2 from "./IntImages/vietnam/vietnam2.png";
import vietnam3 from "./IntImages/vietnam/vietnam3.png";
import vietnam4 from "./IntImages/vietnam/vietnam4.png";

//Azerbaijaan Images
import azer1 from "./IntImages/azerbaijaan/azer1.png";
import azer2 from "./IntImages/azerbaijaan/aer2.png";
import azer3 from "./IntImages/azerbaijaan/azer3.png";
import azer4 from "./IntImages/azerbaijaan/azer4.png";

//Philippines Images
import philip1 from "./IntImages/philippines/philip1.png";
import philip2 from "./IntImages/philippines/philip2.png";
import philip3 from "./IntImages/philippines/philip3.png";
import philip4 from "./IntImages/philippines/philip4.png";

const international = [
  // 1. Japan Tour 7N/8D
  {
    id: 1,
    title: "Noble Japan",
    subtitle: "Osaka - Kyoto - Nara - Tokyo",
    image: japan1,
    images: [japan1, japan2, japan3, japan4, japan5, japan6],
    overview: [
      [
        "A Japan tour offers a blend of hyper-modern cities (Tokyo), ancient traditions (Kyoto's temples, geishas), stunning nature (Mt. Fuji, Miyajima's floating gate), and unique cultural experiences like onsen (hot springs) and bullet trains, typically following the",
        <strong> "Golden Route"</strong>,
        "(Tokyo-Kyoto-Osaka) for shorter trips, while longer tours explore art islands, northern Hokkaido, or southern Kyushu for diverse landscapes and history like Hiroshima. Tours range from budget-friendly to luxury, focusing on culture, food, art, or nature, with options for guided exploration or self-discovery.🇯🇵",
      ],
    ],
    duration: "7 Days / 6 Nights",
    itinerary: [
      {
        day: "01",
        title: "INDIA – OSAKA",
        details: [
          "ARRIVE OSAKA",
          "TRANSFER FROM OSAKA AIRPORT TO CITY",
          "FREE DAY AT LEISURE FOR REST AND EXPLORING THE CITY ON YOUR OWN.",
          "DINNER",
          "OVERNIGHT IN OSAKA.",
        ],
      },
      {
        day: "02",
        title: "OSAKA - KYOTO – OSAKA (Full Day City Tour of Kyoto)",
        details: [
          "BREAKFAST",
          "DEPART TO KYOTO",
          "ARASHIYAMA BAMBOO GROVE",
          "KINKAKU-JI GOLDEN PAVILION",
          "LUNCH",
          "PHILISOPHER PATH",
          "DEPART TO OSAKA",
          "REACH OSAKA",
          "DINNER",
          "AFTER DINNER TRANSFER TO HOTEL",
        ],
      },
      {
        day: "03",
        title: "OSAKA - NARA – OSAKA (Full Day City Tour of Nara and Osaka)",
        details: [
          "BREAKFAST",
          "DEPART TO NARA",
          "TODAI-JI TEMPLE & DEER PARK",
          "LUNCH",
          "PROCEED TO OSAKA",
          "OSAKA CASTLE (PHOTOSTOP)",
          "NISHINOMARU GARDEN",
          "DINNER",
          "AFTER DINNER TRANSFER TO HOTEL",
          "OVERNIGHT IN OSAKA",
        ],
      },
      {
        day: "04",
        title: "UNIVERSAL STUDIOS JAPAN (OSAKA)",
        details: [
          "AFTER BREAKFAST, TRANSFER TO UNIVERSAL STUDIOS OSAKA",
          "Universal Studios Japan is a theme park located in Osaka, Japan.",
          "Opened on March 31, 2001, it is one of six Universal Studios theme parks worldwide and was the second to open outside the United States.",
          "The park is owned and operated by USJ LLC, a wholly owned subsidiary of NBC Universal.",
          "OVERNIGHT IN OSAKA",
        ],
      },
      {
        day: "05",
        title: "OSAKA – TOKYO",
        details: [
          "ARRIVE OSAKA",
          "TRANSFER FROM OSAKA HOTEL TO STATION",
          "STANDARD CHECK-IN TIME TO HOTEL 15:00 HRS",
          "DINNER",
          "AFTER DINNER TRANSFER TO HOTEL AND CHECK-IN",
          "OVERNIGHT IN TOKYO",
        ],
      },
      {
        day: "06",
        title: "FULL DAY TOKYO CITY TOUR",
        details: [
          "BREAKFAST",
          "DEPART TO TOKYO FULL DAY CITY TOUR.",
          "UENO PARK",
          "ASAKUSA SENSOJI KANON TEMPLE",
          "NAKAMISE STREET",
          "IMPERIAL PALACE (DRIVE-BY)",
          "NATIONAL DIET BUILDING (DRIVE-BY)",
          "LUNCH",
          "TOKYO TOWER (150 METERS)",
          "VISIT ODAIBA",
          "DINNER",
          "AFTER DINNER TRANSFER TO HOTEL",
          "OVERNIGHT IN TOKYO",
        ],
      },
      {
        day: "07",
        title: "TOKYO – MT FUJI – TOKYO",
        details: [
          "BREAKFAST",
          "DEPART TO DAY TOUR OF MT FUJI",
          "OSHINO HAKKAI (SPRINGS FROM MT. FUJI)",
          "LUNCH",
          "LAKE KAWAGUCHIKO CRUISE",
          "MT. FUJI PANOROMIC ROPE WAY",
          "DEPART TO TOKYO",
          "REACH TOKYO",
          "DINNER",
          "AFTER DINNER TRANSFER TO HOTEL",
          "OVERNIGHT IN TOKYO",
        ],
      },
      {
        day: "08",
        title: "TOKYO - DEPART AIRPORT",
        details: ["Breakfast", "Check-out of the Hotel", "Depart to Airport"],
      },
    ],
    inclusions: [
      "Meals: 7 - Breakfast at Hotel",
      "7 Nights at 4 STAR HOTEL",
      "Tours with private vehicle",
      "Entrance Fee",
      "International Flight tickets.",
      "All tours and transfers as per the itinerary",
      "Visa fee",
      "Travel Insurance",
    ],
    exclusions: [
      "Optional & Add-On tours unless mentioned otherwise.",
      "Hotel surcharges (if applicable) during high / festive season to be paid extra per person.",
      "Porterage at hotels, airports and seaports, tips, laundry, wines, mineral water, telephone charges, all items of personal nature and also food and drinks not forming part of the touring group’s menu.",
      "Anything not specifically mentioned in ‘What Your Tour Price Includes’ box.",
    ],
  },
  // 2. Japan Tour 7N/8D
  {
    id: 2,
    title: "Japan Refined",
    subtitle: "Osaka - Hiroshima - Kyoto - Nara - Hakone - Tokyo",
    image: japan2,
    images: [japan1, japan2, japan3, japan4, japan5, japan6],
    overview:
      " A Japan tour offers a blend of hyper-modern cities (Tokyo), ancient traditions (Kyoto's temples, geishas), stunning nature (Mt. Fuji, Miyajima's floating gate), and unique cultural experiences like onsen (hot springs) and bullet trains, typically following the \"Golden Route\" (Tokyo-Kyoto-Osaka) for shorter trips, while longer tours explore art islands, northern Hokkaido, or southern Kyushu for diverse landscapes and history like Hiroshima. Tours range from budget-friendly to luxury, focusing on culture, food, art, or nature, with options for guided exploration or self-discovery.🇯🇵",
    duration: "6 Nights / 7 Days",
    itinerary: [
      {
        day: "01",
        title: "INDIA – OSAKA",
        details: [
          "ARRIVE OSAKA",
          "TRANSFER FROM OSAKA AIRPORT TO CITY",
          "STANDARD CHECK-IN TIME TO HOTEL 15:00 HRS",
          "FREE DAY AT LEISURE FOR REST AND EXPLORING THE CITY ON YOUR OWN.",
          "DINNER",
          "OVERNIGHT IN TOKYO.",
        ],
      },
      {
        day: "02",
        title:
          "OSAKA – HIROSHIMA + CITY TOUR OF HIROSHIMA + RETURN BACK TO OSAKA",
        details: [
          "Proceed to Hiroshima by bullet train.",
          "On arrival will do orientation tour of Hiroshima, the city devastated by atomic bomb in World War II.",
          "Visit the Bomb dome, the symbol of Hiroshima and the only building to remain standing after the atomic explosion.",
          "See the Peace Memorial Park with its Museum.",
          "The Cenotaph with its arched tomb is a tribute to those who died because of the bomb.",
          "Next enjoy a ferry ride to Miyajima Island, to see the beautiful Itsukushima Shrine and the floating Torii – one of Japan's most scenic spots.",
          "Later return back to Hiroshima to board the evening bullet train to Osaka.",
          "Meals - Breakfast",
        ],
      },
      {
        day: "03",
        title: "OSAKA – KYOTO & NARA (Full Day City Tour of Kyoto & Nara)",
        details: [
          "BREAKFAST",
          "DEPART TO KYOTO",
          "KINKAKU-JI GOLDEN PAVILION",
          "DEPART TO NARA",
          "TODAI-JI TEMPLE & DEER PARK",
          "AFTER DINNER TRANSFER TO HOTEL",
          "Meals - Breakfast",
        ],
      },
      {
        day: "04",
        title: "KYOTO - HAKONE",
        details: [
          "Visit Kiyomizu Temple.",
          "Take a photo stop at Nijo Castle followed by a visit to Arashiyama bamboo grove – a mesmerizing grove of thousands of tall bamboo plants and one of the Kyoto’s most photographed sights.",
          "We take a brief photostop at Togetsukyo bridge, a 400 year old scenic bridge.",
          "Meals - Breakfast",
        ],
      },
      {
        day: "05",
        title: "HAKONE – MT FUJI –TOKYO",
        details: [
          "BREAKFAST",
          "DEPART TO DAY TOUR OF MT FUJI",
          "OSHINO HAKKAI(SPRINGS FROM MT.FUJI)",
          "LUNCH",
          "LAKE KAWAGUCHIKO CRUISE",
          "MT.FUJI PANOROMIC ROPE WAY",
          "DEPART TO TOKYO",
          "REACH TOKYO",
          "DINNER",
          "AFTER DINNER TRANSFER TO HOTEL",
          "OVERNIGHT IN TOKYO",
          "Meals - Breakfast",
        ],
      },
      {
        day: "06",
        title: "FULL DAY TOKYO CITY TOUR",
        details: [
          "BREAKFAST",
          "DEPART TO TOKYO FULL DAY CITY TOUR.",
          "UENO PARK",
          "ASAKUSA SENSOJI KANON TEMPLE",
          "NAKAMISE STREET",
          "IMPERIAL PALACE(DRIVE-BY)",
          "NATIONAL DIET BUILDING(DRIVE-BY)",
          "TOKYO TOWER (150 METERS)",
          "VISIT ODAIBA",
          "AFTER DINNER TRANSFER TO HOTEL",
          "OVERNIGHT IN TOKYO",
          "Meals - Breakfast",
        ],
      },
      {
        day: "07",
        title: "FREE DAY ON OWN",
        details: ["FREE DAY ON OWN"],
      },
      {
        day: "08",
        title: "TOKYO - DEPART AIRPORT",
        details: [
          "BREAKFAST",
          "CHECK-OUT OF THE HOTEL",
          "DEPART TO AIRPORT",
          "Meals - Breakfast",
        ],
      },
    ],
    inclusions: [
      "Meals: 06 - Breakfast at Hotel",
      "06 Nights at given Hotel based on 4 star hotels.",
      "Tours with Van and English speaking driver",
      "Bullet train ticket (Reserved Seat) as mentioned in itinerary",
      "Entrance Fee",
      "International Flight tickets.",
      "Visa fee",
      "Travel Insurance",
    ],
    exclusions: [
      "Optional & Add-On tours unless mentioned otherwise.",
      "Guide Tips",
      "Lunch & Dinners",
      "Hotel surcharges (if applicable) during high / festive season to be paid extra per person.",
      "Porterage at hotels, airports and seaports, tips, laundry, wines, mineral water, telephone charges, all items of personal nature and also food and drinks not forming part of the touring group’s menu.",
      "Anything not specifically mentioned in ‘What Your Tour Price Includes’ box.",
    ],
  },
  // 3. Thailand Tour 4N/5D
  {
    id: 3,
    title: "Thailand Discovery",
    subtitle: "Bangkok - Pattaya - Coral Island",
    image: thailand1,
    images: [thailand1, thailand2, thailand3, thailand4, thailand5, thailand6],
    overview: [
      [
        "Thailand is a vibrant destination known for its rich culture, colorful markets, and lively city life. Explore Bangkok’s iconic temples, royal palaces, and bustling floating markets. Enjoy exciting nightlife, street food, and world-class shopping experiences. Discover beautiful beaches and fun activities in Pattaya and nearby islands. Experience traditional Thai massages, cultural shows, and warm hospitality. A Thailand tour offers the perfect balance of culture, entertainment, and relaxation.🇹🇭",
      ],
    ],
    duration: "4 Nights / 5 Days",
    itinerary: [
      {
        day: "01",
        title: "ARRIVAL AT BANGKOK TO PATTAYA",
        details: [
          "On arrival you will be met by our local representative and go towards pattaya.",
          "En route had your breakfast at sriracha tiger zoo",
          "Had your lunch at Indian restaurant.",
          "After lunch you will go to",
          "Later check in the hotel and had your dinner",
          "Overnight stay at pattaya.",
        ],
      },
      {
        day: "02",
        title: "CORAL ISLAND",
        details: [
          "Visit to Coral Island – the Island",
          "After your luscious breakfast in the morning get set to explore the beauty of Coral Island.",
          "Commence (approx 0800 Hours) with the energizing ride in a speed boat to the KoLarn Island where you can enjoy mu and jet skis.",
          "Snorkeling and deep",
          "KohKrok and KohSak, where there is an abundance of coral and undersea life waiting to be discovered.",
          "Also view the colorful and bountiful underwater life without getting wet as you gaze at them from aboard a glass bottom boat.",
          "Rest of the day is free for your personal activity",
          "Back to the hotel and overnight stay at pattaya.",
        ],
      },
      {
        day: "03",
        title: "PATTAYA – BANGKOK",
        details: [
          "Morning after breakfast check out from the hotel and go towards Bangkok.",
          "Check in the hotel.and go for the Bangkok city tour and visit",
          "sleeping Buddha and gems gallery",
          "Later go back to the hotel and had your dinner .",
          "Overnight stay at hotel.",
        ],
      },
      {
        day: "04",
        title: "SAFARI WORLD AND MARINE PARK",
        details: [
          "Morning after breakfast go for safari world and marine park.",
          "Safari World and Marine Park in Bangkok is a fun day out for the whole friends.",
          "The variety of things to see and do makes this a fun and enjoyable place for",
          "Go back to the hotel and overnight stay at hotel.",
        ],
      },
      {
        day: "05",
        title: "DEPARTURE BANGKOK",
        details: [
          "After your breakfast checkout from the hotel.",
          "Time for shopping and transfer to airport for board your flight.",
          "Tour Ends",
        ],
      },
    ],
    inclusions: [
      "02 Nights accommodation at Hotel in Pattaya.",
      "02 Nights accommodation at Hotel in Bangkok.",
      "Meal plan on Breakfast and dinner",
      "Coral Island Tour + Lunch",
      "Bangkok City Tour",
      "Safari world",
      "marine park",
      "Tours and Transfers as per the itinerary.",
      "Roundtrip Flight Tickets",
      "Applicable all the Taxes",
    ],
    exclusions: [
      "Personal Expenses",
      "RTPCR TEST",
      "Lunch",
      "Tips",
      "Any other expenses not mentioned in the inclusions",
    ],
  },
  // 4. Thailand Tour 4N/5D (Phuket & Krabi)
  {
    id: 4,
    title: "Thailand Indulgence (Phuket & Krabi)",
    subtitle: "Phuket - Krabi - Phi Phi Island",
    image: phuket1,
    images: [phuket1, phuket2, phuket3, phuket4, phuket5, phuket6],
    overview: [
      [
        "Thailand’s Phuket, Krabi, and Phi Phi Islands offer a perfect tropical escape with stunning beaches and turquoise waters. Phuket blends vibrant nightlife, luxury resorts, and cultural attractions. Krabi is known for its dramatic limestone cliffs, serene beaches, and emerald lagoons. Phi Phi Islands captivate travelers with crystal-clear seas and scenic island landscapes. Enjoy island hopping, snorkeling, and unforgettable sunset views. This island tour promises relaxation, adventure, and breathtaking natural beauty.🇹🇭",
      ],
    ],
    duration: "4 Nights / 5 Days",
    itinerary: [
      {
        day: "01",
        title: "PHUKET TO KRABI ENROUTE",
        details: [
          "We’ll meet you at the airport and transfer Krabi and Later drop to the hotel.",
          "Rest of the day at leisure and Overnight in your stay.",
          "(Meals: Breakfast)",
        ],
      },
      {
        day: "02",
        title: "04 ISLANDS TOUR BY SPEED BOAT",
        details: [
          "Breakfast at Hotel",
          "04 Islands tour by Long Tailboat",
          "Snorkeling and swimming at Chicken Island or Koh Kai in Thai because its shape looks like a chicken.",
          "You'll be surprised by the sand banks which separate Chicken Island,Tup and Moore Islands when it is low tide.",
          "Visit Phra Nang Cave at Railay beach",
          "Pick you up fromy our hotel",
          "Get on speed boat to sand banks at Chicken,Tup and Moore Islands.",
          "Snorkeling and swimming at Chicken Island and also have picnic lunch here",
          "Straight to Poda Island for have lunch.",
          "Sun bathing ,swimming and relaxing on the beautiful white sand beach.",
          "Also taking picture with the background of a beautiful standing hill",
          "On the way back we'll pass Phra Nang Cave.",
          "Pray homage to the spirit of Phra Nang.",
          "Back to the pier then transfer you back to your hotel.",
          "Remark:the details of program can be changed depend on the level of the water tide or the condition of the weather.",
          "What to bring:Sunscreen,Sunglasses,Camera,Hat,Towels,Swimmingsuit",
          "Tourincludes:Hotel Transfer,Entrance Fees, Accident Insurance, Mask &Snorkel, Life Jacket ,First-aid Kit, Drinking water, Fruit, Lunch and English-Speaking Guide",
          "Overnight at the Hotel.",
          "(Meals: Breakfast)",
        ],
      },
      {
        day: "03",
        title: "DEPARTURE KRABI TO PHUKET + PHUKET CITY TOUR",
        details: [
          "Breakfast at Hotel and transfer to Phuket hotel.",
          "Later Visit Phuket View Point and Visit century – old Sino-Portuguese building sat Thalang Road and learn more about Phuket’s colorful history.",
          "Overnight in Hotel.",
        ],
      },
      {
        day: "04",
        title: "PHUKET - PHI PHI ISLAND",
        details: [
          "Enjoy cruising by speed boat to Phi Phi Island Group.",
          "Phi Phi Island is one of the best places in the world for its beautiful marine life resources.",
          "Pick you up from your hotel 08.00 - 08.30.",
          "Get on a speed boat for Phi Phi with sightseeing at Viking Cave and Phi Phi lagoon, one of the most beautiful lagoons.",
          "Stop at Loh Sa Ma Bay for swimming, snorkelling.",
          'Heading to Maya Bay,it is very beautiful that is why by the year 2000 it was took the film named "The Beach" there.',
          "After Maya Bay we will go to Monkey Bay.",
          "You will be greeted by many small monkeys.",
          "Have adelicious buffet lunch and relax at the rest aurant on PhiPhi Island.",
          "After lunch more snorkeling at Hin Klang.",
          "It is open sea snorkeling along the colorful coral reef gardens with exotic fish.",
          "By the end we stop and spend the time for swimming, relaxing and sun bathing at Bamboo Island",
          "Back to the pier and transfer you back to your hotel",
          "Remark: the details of program can be changed depending on the tide or the weather conditions.",
          "Tour includes:Hotel Transfer,Entrance,Mask & Snorkel, LifeJacket, First-aid Kit, water/soda, fruit, lunch and English-speaking guide.",
          "Overnight in your stay.",
          "(Meals: Breakfast )",
        ],
      },
      {
        day: "05",
        title: "PHUKET – BANGALORE",
        details: [
          "Ta– Ta!!",
          "After your breakfast at hotel, you have time to freak around the city and shop.",
          "In the morning you depart from Phuket .",
          "Later board your flight for India with the good memories of your trip by M D TOURS AND TRAVELS",
          "(Meals:Breakfast)",
        ],
      },
    ],
    inclusions: [
      "02 nights stay in the Phuket",
      "04Island tour in long tail boat (SIC)",
      "02 nights in Krabi",
      "Krabi to Phuket by Road",
      "Phi Phi Island tour in big boat with (SIC)",
      "Phuket  city tour(PVT)",
      "05 Breakfast at Hotel",
      "Return air port transfers",
      "All sightseeing as mentioned in Itinerary",
      "Airfare & Airport taxes",
      "GST-5.00",
      "Visa Charges of Thailand",
    ],
    exclusions: [
      "Lunch & Dinner",
      "Any other not mentioned in the inclusions.",
      "Personal Expenses",
      "The National Park fees THB400/pax applicable for each Island tours –expense to be paid by client directly.",
      "Early check in and late check out are subject to availability and can not be guaranteed.",
      "Normal check in time is 1400hr sand check out time is1200 hrs.",
    ],
  },
  // Vietnam 6N/7D
  {
    id: 4,
    title: "Vietnam Essence",
    subtitle:
      "Hanoi - Ninh Binh - Halong Bay - Hanoi - Danang - Coconut Forest - Hoi An ",
    image: vietnam1,
    images: [vietnam1, vietnam2, vietnam3, vietnam4],
    overview: [
      [
        "Vietnam is a captivating destination known for its rich history, vibrant culture, and breathtaking landscapes. From the bustling streets of Hanoi to the modern energy of Ho Chi Minh City, the country offers diverse experiences. Cruise through the emerald waters of Ha Long Bay and admire its limestone karsts and islands. Explore ancient towns like Hoi An, famous for lantern-lit streets and traditional architecture. Vietnamese cuisine delights travelers with flavorful dishes such as pho, banh mi, and fresh seafood. With warm hospitality and unforgettable scenery, Vietnam offers a perfect blend of culture, nature, and adventure. 🇻🇳",
      ],
    ],
    duration: "6 Nights / 7 Days",
    itinerary: [
      {
        day: "01",
        title: "HANOI ARRIVAL – HALF DAY CITY TOUR",
        details: [
          "Upon arrival in Hanoi, you will be warmly greeted by",
          "Then transfer from the airport to the hotel for check in and rest to regain your energy.",
          "Afternoon, we will visit:",
          "Tran Quoc Pagoda",
          "Hoan Kiem Lake",
          "Train Street: You can visit this special street of Vietnam after dinner, seeing train going through while having a coffee is the best way to enjoy the Vietnamese atmosphere.",
          "Over night Hanoi.",
        ],
      },
      {
        day: "02",
        title: "HANOI – NINH BINH – SIC TOUR",
        details: [
          "Breakfast in the hotel.",
          "7h00 : Our tour guide will pick you up from your hotel. We take you to Ninh Binh province which is far from Hanoi city about 120 km.",
          "9h00 :Have a short break for 20 minutes to relax",
          "10h30: The first destination in this trip is visit Hoa Lu ancient capital.",
          "Come to visit Hoa Lu, you will learn about why the capital was moved to Hanoi nowadays.",
          "You are impressed on an outstanding architecture when entering temples of King Dinh and King Le, the first and second emperors of ancient Vietnam, built in the 17 century.",
          "Try to feel ancient atmospheres in Hoa Lu ancient capital.",
          "12h30: Have buffet local lunch in the restaurant",
          "13h30 – 14h00 : Visit Trang An which was recognized by UNESCO as The world Heritage Site in 2014.",
          "Trang An has the wonderful tunnel cave system so that Kong’s Movie Group chose this place for New Version of Kong in 2016 – “ Skull Island “.",
          "Boat trip to visit Trang An to see the amazing beauty of this landscape with many caves such as : Sang Cave (Light Cave), Toi Cave (Dack cave), Nau Ruou Cave (Cooking Wine), green river and natural view.",
          "16h00 : Get on the bus to return to Hanoi",
          "18h30 – 19h00 : Arrive back to Hanoi and drop off at your hotel or our office in Hanoi.",
          "Overnight in Ha Noi.",
        ],
      },
      {
        day: "03",
        title: "HANOI – HALONG BAY BY BUS – OVERNIGHT ON CRUISE",
        details: [
          "Breakfast in the hotel",
          "07.45 – 08.30: You will be picked up from your hotel in Ha Noi Old Quarter.",
          "Then we will head to Ha Long Bay.",
          "You may enjoy the landscape of the Red River Delta along the way",
          "11.30: Upon arriving in our lobby in Tuan Chau Marina, you may take a short stretch while our staff arranges all registration with the local government.",
          "12.00 – 12.30: The cruise captain and staff will welcome you onboard CRUISE after a short tender transfer.",
          "While enjoying a refreshing welcome drink, a short cruise briefing and safety instructions will be given.",
          "12.30 – 13.00: CRUISE voyages to Ha Long Bay – one of the New Seven Nature Wonders of the World.",
          "Lunch is served on board while the cruise passes via amazing limestone karst formations that rise up out of the sea in an impressive manner.",
          "14.00 – 14.30: You will leave the cruise to explore Sung Sot Cave (also known as Surprise/ Amazing Cave), one of the biggest and most beautiful caves in Ha Long Bay.",
          "15.00: Returning to CRUISE, the trip will continue to Ti Top Island.",
          "Here, you can watch the magnificent view over either the Gulf of Tonkin or swim in the emerald green and cool water.",
          "17.00: After a long day, this is the ideal time to enjoy energizing drinks and snacks by joining ‘Happy Hour’ or Cooking Class on the sundeck",
          "19.30: Sumptuous Dinner is served.",
          "Enjoy delicious local food prepared and served for you by our wonderful onboard catering staff.",
          "20.30: After dinner, various activities including karaoke, and squid fishing are organized.",
          "Overnight on cruise.",
        ],
      },
      {
        day: "04",
        title: "HALONG BAY – HANOI BY BUS – DANANG BY FLIGHT",
        details: [
          "06.15 – 07.00: Breakfast is served.",
          "It can be a great idea to enjoy the meal with the magnificent view of the sunrise in Ha Long Bay.",
          "8.00 -9.30: The cruise gets closer to the center of the Natural Preservation Area.",
          "Join our guide on a short trip to Luon Cave.",
          "You can discover this time masterpiece by kayaking on your own.",
          "9.30: Cruise welcomes you back on board and it is time for checking out.",
          "10.00: Whilst cruising back, delightful lunch will be served.",
          "11.35: We return to the quayside in the south of the bay, where our visitors disembark in Tuan Chau Marina.",
          "15.30 – 16.00: You will get back to your hotel in Ha Noi.",
          "Transfer to Noi Bai airport to take a flight to Danang.",
          "Upon arrival in Danang will take you to your hotel for check in.",
          "Overnight in Danang.",
        ],
      },
      {
        day: "05",
        title: "DANANG – COCONUT FOREST – HOI AN",
        details: [
          "Breakfast at hotel",
          "Depart from the hotel for Coconut Forest",
          "Then drive to visit Bay Mau water coconut forest",
          "Visitors will experience floating down the river by basket boat",
          "Return to Hoian before an afternoon walking tour.",
          "You’ll see the charming, old port of narrow streets and traditional houses.",
          "Then come back to Danang",
          "Overnight in Danang.",
        ],
      },
      {
        day: "06",
        title: "DANANG – BANA HILLS – GOLDEN BRIDGE – SIC",
        details: [
          "Breakfast at the hotel.",
          "07h00 – 08h00: Pick up at HOTEL. Depart to Ba Na Hills.",
          "09h00: Arrive at the cable car station Suoi Mo.",
          "Visit the 150-meter long Golden Bridge supported by the huge hands.",
          "Visit the Le Jardin, Debay Wine Cellar of French.",
          "Visit the Linh Ung pagoda, admire the 27m high Buddha statue.",
          "Continue to Gare Debay use the second cable car route to go to the top of Ba Na.",
          "The tour guide will take guests to visit Fantasy Park.",
          "Freedom to rest. Conquer the Peak of Chua mountain at the height of 1,487m.",
          "Enjoy the panorama view of the Da Nang City and Da Nang Bay.",
          "Then return to cable car station and back to Da Nang.",
          "Overnight in Danang.",
        ],
      },
      {
        day: "07",
        title: "DANANG – DEPARTURE",
        details: [
          "Breakfast in the hotel.",
          "Transfer to Danang airport for departure to next destination.",
          "It’s time to say goodbye, we thank you for traveling with us and warmly welcome you to come again.",
        ],
      },
    ],
    inclusions: [
      "Ground transportation in air-conditioned vehicle",
      "Accommodation at hotel as mentioned or similar ones",
      "Mineral water during excursion 2 bottles/Pax/Day",
      "All services mentioned in the program",
      "Sightseeing tickets",
      "Visa of both countries",
      "Accommodation as indicated above twin including all taxes and breakfast",
    ],
    exclusions: [
      "Surcharge for public holiday or any compulsory dinner on Christmas and New Year",
      "Personal expenses and beverage",
      "Travel insurance",
      "Items of a personal nature",
      "Early check in and late check out surcharge",
      "International and domestic flights including airport tax",
      "Other meals and services not mentioned below",
    ],
  },
  // Azerbaijaan 6N/7D
  {
    id: 4,
    title: "Azerbaijan Aura",
    subtitle: "Baku - Shadag - Abeshron - Gobustan - Gabala  ",
    image: azer1,
    images: [azer1, azer2, azer3, azer4],
    overview: [
      [
        "Azerbaijan is a fascinating destination where ancient history meets modern architecture. The capital city, Baku, showcases a stunning mix of futuristic skyline and UNESCO-listed Old City charm. Travelers can explore the scenic Caspian Sea coastline and the unique landscapes of Gobustan. Azerbaijan is known for its rich Silk Route heritage, traditional music, and vibrant local culture. The country also offers diverse experiences, from mountain villages to luxury shopping and dining. With warm hospitality and unique contrasts, Azerbaijan promises a memorable and enriching travel experience. 🇦🇿",
      ],
    ],
    duration: "5 Nights / 6 Days",
    itinerary: [
      {
        day: "01",
        title: "ARRIVAL – BAKU",
        details: [
          "Arrival To Baku Airport",
          "Meet & Greet At The Airport",
          "Transfer To Hotel",
          "Check Inn At 15h00",
          "Little Venice Boat Ride",
          "Walking Down To Boulevard Park Along The Seaside Boulevard",
          "Funicular Ride",
          "Evening Tour With Photo Stops At Flame",
          "Drop To Hotel",
        ],
      },
      {
        day: "02",
        title: "FULL-DAY BAKU TOUR",
        details: [
          "Morning Breakfast At Hotel",
          "Depart For - Old City Tour: Icheri Sheher",
          "Baku Old City Tour – Palace.",
          "Nizam Street (Old Trading Zone With A Lot Of Souvenir Shops)",
          "Nizami Square Tour",
          "Photo Stop At Nizami Street,",
          "Heydar Aliyev Center & I Love Baku (Photo Stop)",
          "Drop To Hotel",
        ],
      },
      {
        day: "03",
        title: "SHADAG TOUR",
        details: [
          "Morning Breakfast At Hotel",
          "Shadag - Day Trip To Shadag Complex To Explore At The Activity.",
          "Passed By Qusar (Oreintation)",
          "Shahdag Cable Car",
          "Drop To Hotel",
        ],
      },
      {
        day: "04",
        title: "ABESHRON + GOBUSTAN TOUR",
        details: [
          "Morning Breakfast At Hotel",
          "Proceed To Absheron Tour",
          "Baku Absheron Tour – With Entry Tickets",
          "Gobustan Tour – Gobustan Mud Volcano Visit",
          "Drop To Hotel",
        ],
      },
      {
        day: "05",
        title: "BAKU - GABALA TOUR",
        details: [
          "Morning Breakfast At Hotel",
          "Check Out From Baku & Enroute Ga",
          "Explore Gabala",
          "Gabala – Nohur Lake (Photo Stop) ,",
          "Points Only)",
          "Drop To The Hotel",
          "Check Inn & Relax",
        ],
      },
      {
        day: "06",
        title: "DEPARTURE",
        details: [
          "Morning Breakfast At Hotel",
          "Check Out At The Hotel",
          "Drop To Airport",
          "TOUR ENDS WITH M D TOURS AND TRAVELS",
        ],
      },
    ],
    inclusions: [
      "05 Nights & 06 Days Stay In Above Mentioned Hotels Or Similar",
      "All Transfers In Sedan 03 Seats Or Similar + English Speaking Driver (Not Fluent)",
      "Entry Tickets Inclusive Gobustan Mud Volcano Visit + G Ride + Funicular Ride + Shahdag Cable Car",
      "2 X 250 Ml Water Bottle Pp Per Day",
      "Baku E Visa",
      "Below Itinerary Inclusive",
      "Ateshgah – (Fire Temple) & Yanardag – (Burning Mountain)",
      "Gobustan Mud Volcano Visit",
      "Nohur Lake (Photo Stop) ,  Tufandag Cable Car Ride With Entry Tickets",
      "Gobustan Mud Volcano Visit + Gabala Cable Car (Two Points) + Little Venice Boat Ride + Funicular Ride + Shahdag Cable Car",
    ],
    exclusions: ["Lunch And Dinner Indian Menu", "English Speaking Guide"],
  },
  // Philippines 6N/7D
  {
    id: 4,
    title: "Serene Philippines",
    subtitle: "Manila - Clark/Angeles - Cebu - Twin City ",
    image: philip1,
    images: [philip1, philip2, philip3, philip4],
    overview: [
      [
        "The Philippines is a stunning tropical destination made up of over 7,000 beautiful islands. It is famous for its crystal-clear beaches, turquoise lagoons, and world-class diving spots. Travelers can explore vibrant cities, pristine islands like Boracay, Palawan, and Cebu, and rich marine life. The country offers a perfect mix of relaxation, adventure, and cultural experiences. Filipino cuisine and warm hospitality make every visit welcoming and memorable.With breathtaking scenery and diverse island experiences, the Philippines promises an unforgettable holiday.🇵🇭",
      ],
    ],
    duration: "6 Nights / 7 Days",
    itinerary: [
      {
        day: "01",
        title: "ARRIVAL IN MANILA",
        details: [
          "Arrived in Manila, Philippines",
          " Meet and Greet at the Airport",
          "Check in Hotel",
          "Overnight stay in Manila",
        ],
      },
      {
        day: "02",
        title: "MANILA CITY TOUR + DESTILERIA MUSEUM",
        details: [
          "Breakfast at the Hotel",
          " Pick up from your hotel / Start Manila City Tour + Destileria Museum",
          "RIZAL PARK - Immerse yourself into Philippines history at the Rizal Park named after Dr. Jose Rizal, Philippine national hero.",
          "INTRAMUROS - also known as the Walled City that was considered as Manila itself during the Spanish colonial period",
          "FORT SANTIAGO - The fort is one of the most important historical sites in Manila. Several lives were lost in its prisons during the Spanish Colonial Period and World War II. José Rizal, the Philippine national hero, was imprisoned here before his execution in 1896.",
          "SAN AGUSTIN CHURCH",
          "MANILA CATHEDRAL",
          "CULTURAL CENTER OF THE PHILIPPINES provides performance & exhibition venues for various local and international productions",
          "DESTILERIA LIMTUACO MUSEUM - Philippines, dating back to the Spanish colonial period. (Wine Tasting)",
          " Indian Lunch at Resto",
          " Shopping Tour",
          " Back to the Hotel",
          " Overnight stay in Manila",
        ],
      },
      {
        day: "03",
        title: "TRANSFER TO CLARK / ANGELES",
        details: [
          " Breakfast at the Hotel",
          " Check out / Transfer to Clark/Angeles",
          "*Approx 2-2.5 hours of land drive depending on traffic conditions*",
          " Check In Hotel",
          " Overnight stay in Clark/Angeles",
        ],
      },
      {
        day: "04",
        title: "CLARK & ANGELES CITY TOUR",
        details: [
          " Breakfast at the Hotel",
          " Pick up from your hotel / Clark & Angeles City Tour",
          "PAMINTUAN MANSION",
          "HOLY ROSARY PARISH CHURCH",
          "NEPO Market (Local Market Shopping)",
          "CLARK FREEPORT ZONE",
          "AIR FORCE CITY PARK",
          "ROYALE CASINO",
          " Indian Lunch at Restaurant",
          " Back to the Hotel",
          " Overnight stay in Clark/Angeles",
        ],
      },
      {
        day: "05",
        title: "FLIGHT TO CEBU",
        details: [
          " Breakfast at the Hotel",
          " Check out / Transfer to Clark Airport",
          "*Guests must be at the airport 2 hours prior to departure*",
          " Flight to Cebu",
          " Arrival in Cebu / Transfer to Hotel",
          " Overnight stay in Cebu",
        ],
      },
      {
        day: "06",
        title: "TWIN CITY TOUR",
        details: [
          " Breakfast at the Hotel",
          " Pick up from your hotel / Twin City Tour",
          "Lapu-Lapu Monument",
          "Magellan’s Shrine",
          "Alegre Guitar Factory",
          "Magellan’s Cross",
          "Basilica Minore Del Sto. Nino",
          "The Heritage of Cebu Monument",
          "Yap-San Diego Ancestral House or Casa Gorordo Museum",
          "Taoist Temple",
          "Running Tour: South Road Properties, Colon Street, Fuente Osmena Circle, Capitol Site",
          " Local Lunch at Resto",
          " Back to the Hotel",
          " Overnight stay in Cebu",
        ],
      },
      {
        day: "07",
        title: "DEPART CEBU",
        details: [
          " Breakfast at the hotel",
          " Check out Hotel / Transfer to Cebu Airport",
          "*Guest must be at the airport 3 hours before the flight*",
          " Flight Out with Cherished Memories",
        ],
      },
    ],
    inclusions: [
      "Hotel Accommodation",
      "Daily Hotel Breakfast",
      "Roundtrip Airport Transfer as per itinerary",
      "Tours and activities as per itinerary",
      "Meal as per itinerary",
      "Applicable Entrance Fees on tour",
      "English-Speaking Guide on tours (DOT Accredited)",
      "Daily bottled water on tours",
      "Domestic flight",
    ],
    exclusions: [
      "Airfare from the country of origin",
      "Domestic Airfare (if any)",
      "All personal incidental expenses",
      "All items/services not mentioned in the inclusions",
      "Tipping’s (Driver/Guide/Coordinator/boatmen)",
      "Travel Insurance (available upon request)",
      "5% GST and bank transfer charge",
    ],
  },
  // 5. Sri Lanka Tour 4N/5D
  {
    id: 5,
    title: "Sri Lanka",
    subtitle: "Colombo - Kandy - Bentota",
    image: lanka1,
    images: [lanka1, lanka2, lanka3, lanka4, lanka5],
    overview: [
      [
        "Sri Lanka is a diverse island nation known for its rich heritage, lush landscapes, and golden beaches. Explore ancient cities, sacred temples, and UNESCO World Heritage sites. Enjoy scenic hill country views with tea plantations and misty mountains. Experience thrilling wildlife safaris in national parks like Yala. Indulge in flavorful Sri Lankan cuisine and warm local hospitality. A Sri Lanka tour offers culture, nature, adventure, and relaxation in one journey.🇱🇰",
      ],
    ],
    duration: "4 Nights / 5 Days",
    itinerary: [
      {
        day: "01",
        title: "ARRIVE COLOMBO AIRPORT AND DRIVE TO KANDY (3HRS/102KMS)",
        details: [
          "Meet and assist on arrival at Airport, Transfer from Colombo Airport to Kandy.",
          "Upon arrival Kandy, check In to Hotel and relax.",
          "Later in the evening proceed to Kandy city tour - Drive around the Kandy Lake.",
          "Visit the Kandy town, the bazaar, an arts & crafts centre and a gem museum / lapidary.",
          "Temple of the Tooth Relic and thereafter witness a cultural show.",
          "Over night stay in Kandy.",
        ],
      },
      {
        day: "02",
        title: "KANDY TO BENTOTA (04 HRS30 MINS/173KMS)",
        details: [
          "Breakfast at Hotel.",
          "Check out from hotel and proceed to Peradeniya Royal Botanical Garden - Peradeniya are about 5.5km to the west of the city of Kandy in the Central Province of Sri Lanka.",
          "It is near the Mahaweli River (The longest river in Sri Lanka).",
          "It is renowned for its collection of orchids.",
          "The garden includes more than 4000 species of plants, including orchids, spices, medicinal plants and palm trees.",
          "Enroute visit Pinnawala Elephant Camp - The orphanage was established in 1975 and commenced with seven orphaned elephants.",
          "It is most interesting to visit at feeding time to see the baby elephants being bottle fed and the entire herd taken for a bath thereafter to the river nearby.",
          "Later proceed to Bentota, upon arrival check in to hotel and rest of the day is yours to explore Bentota by your own.",
          "Overnight stay in Bentota.",
          "Meals–Breakfast",
        ],
      },
      {
        day: "03",
        title: "BENTOTA SIGHTSEEING",
        details: [
          "Breakfast at Hotel.",
          "Later proceed to Kosgoda Turtle Hatchery - Both local and international volunteers battling it out for ''Sea Turtles' Sake'' is a common sight at Kosgoda.",
          "This vibrant tourist destination sitting calm along the Southern coast of Sri Lanka.",
          "Later recognized by the Wildlife Protection Society who studded the region with a Sea Turtle Conservation Project which operates on a formidable scale today.",
          "Then visit Balapitiya Tour from Bentota - Balapitiya is where one could just sit back and observe how ecology and culture combines under the sun.",
          "Cut through the clear water of Madu River - a lifeline of Balapitiya – and head towards Kotu Duwa, the small island housing a temple that dates back to ancient Sinhalese kings.",
          "Return back to hotel and rest of the day is time for water sports activities – own expenses.",
          "Overnight stay at Bentota.",
          "Meals–Breakfast",
        ],
      },
      {
        day: "04",
        title: "BENTOTA – COLOMBO (1HRS50MIN/82.4KMS)",
        details: [
          "Breakfast at Hotel.",
          "Check out from the hotel proceed to Colombo.",
          "Colombo City and Shopping tour - The throbbing metropolis, Colombo located in the West.",
          "Drive along the clean streets edging the crystal white Race Course - horse racing hub in 1893 & World War II airstrip.",
          "Ride to Pettah & tune into the Floating Market.",
          "Visit Colombo Port City, Bauddhaloka Mawatha, Arcade, Independence Square.",
          "Visit Dutch Hospital and Gangarama temple.",
          "Check in to hotel and overnight Stay at Colombo.",
          "Meals–Breakfast",
        ],
      },
      {
        day: "05",
        title: "DEPARTURE",
        details: [
          "Breakfast at Hotel.",
          "Check out from hotel and drop off to Colombo Airport for departure flight.",
          "Meals–Breakfast",
        ],
      },
    ],
    inclusions: [
      "01 Night Accommodation in Kandy",
      "02 Night Accommodation in Bentota",
      "01 Night Accommodation in Colombo",
      "05 Breakfast (Except on arrival day) included at hotel & Dinner",
      "All the transfers and sightseeing as per the Itinerary and on Private Basis",
      "02 Water Bottles (500ml) per person on per day",
      "Free tickets to be collected for cultural show when visit gem gallery",
      "Complementary Spice Garden visit",
      "Airfare",
      "Visa Fees",
      "Entrance fees",
    ],
    exclusions: [
      "Lunch",
      "GST and TCS",
      "Any other expenses not mentioned under the Inclusions",
      "Bank Charges",
      "Early check in or later check out",
      "Vehicle use for Nightlife",
      "Tips and Porterage and any other expenses not mentioned in inclusion list",
    ],
  },
  // 3. South Korea Tour 7N/8D
  {
    id: 3,
    title: "South Korea Explorer",
    subtitle: "SEOUL - BUSAN - JEJU",
    image: sk1,
    images: [sk1, sk2, sk3, sk4, sk5, sk6],
    overview:
      " South Korea offers a rich blend of ancient traditions andcutting-edge modern life. Experience historic palaces, traditional Hanok villages, and age-old customs rooted in Confucian and Buddhist culture. Witness colorful festivals, traditional Hanbok attire, and classical performances like Samulnori and Taekwondo. Savor authentic Korean cuisine shaped by centuries of heritage, from kimchi to royal court dishes. With warm hospitality and deep cultural pride, South Korea delivers a meaningful and immersive travel experience. 🇰🇷",
    duration: "7 Nights / 8 Days",
    itinerary: [
      {
        day: "01",
        title: "SEOUL: ARRIVAL AND LEISURE DAY",
        details: [
          "On arrival, meet our representatives and head to the hotel.",
          "Spend the day at your leisure and have a good night’s sleep.",
        ],
      },
      {
        day: "02",
        title: "SEOUL: SIGHTSEEING",
        details: [
          "Explore the culture of Korea and end the day with some shopping to fill your heart.",
          "Grab a delicious meal of breakfast at the hotel, get ready for the day and proceed for some sightseeing.",
          "Go to places like the Blue House and President’s House.",
          "Next, proceed to the Jogyesa Buddhist temple, one of the most prominent tourist spots in Korea.",
          "Admire the trees at the entrance and enter the temple, 500 years old.",
          "Next is the Gyeongbokgung Palace that showcases royalty.",
          "Let the guide unveil the beauty of the palace for you.",
          "After this fill your tummies with tasty Korean lunch before heading to Changdeokgung Palace.",
          "The massive gates, the gigantic building enthralls you.",
          "Wander down to markets, local restaurants and other places of interest.",
        ],
      },
      {
        day: "03",
        title: "SEOUL: FULL-DAY TOUR TO NAMI ISLAND AND PETITE FRANCE",
        details: [
          "A stroll in the countryside accompanied by sightseeing at the Nami Island.",
          "The popularity explosion of Korean pop culture has spread across Southeast Asia, and with this tour, you get to experience it for yourself.",
          "Visit the major filming sites and live the ever-growing Korean Wave.",
          "Nami Island is one of the most famous islands in South Korea for being the filming location of the TV drama “Winter Sonata”.",
          "Visiting this place is a must.",
          "Do not forget to visit Petite France and the Garden of Morning Calm.",
          "End the tour with a shopping stroll in the market.",
          "Stay overnight in the hotel.",
        ],
      },
      {
        day: "04",
        title: "SEOUL TO BUSAN BY TRAIN + EXPLORE BUSAN",
        details: [
          "Busan is today's destination, where you'll board the KTX high-speed train traveling south for about three hours and then meet your driver for a transfer to your hotel.",
          "Ease your way into the city and feel the laid-back atmosphere on Dadaepo Beach.",
          "Then join your local guide for a food tour of Jagalchi Fish Market, among South Korea's largest.",
          "Weave through narrow alleyways lined with stalls to pick your fish on the main floor.",
          "Head up to the market's second floor to select a restaurant to turn your selection into a meal.",
          "After the food tour, arrive in BIFF Square, a central shopping and dining district.",
          "Browse among vendors selling tteokbokki, mandu dumplings, gimbap, and hotteok.",
          "After a full day of food adventure, return to your hotel for the evening.",
        ],
      },
      {
        day: "05",
        title: "BUSAN SIGHTSEEING",
        details: [
          "Visit Haedong Yonggungsa, Haewundae Beach & Gwangalli Food Tour.",
          "With your guide and driver leading the way, see Busan and the surrounding area today.",
          "Arrive at Haedong Yonggungsa and walk the grounds of a 14th-century Buddhist temple.",
          "Travel to the Sky Capsule to admire more scenery along the shore.",
          "For lunch, try local specialties such as jangeo-gui grilled eel or bibim dangmyeon.",
          "Spend the afternoon at Haeundae Beach.",
          "Head back to the city as the sun sets for a food tour around Gwangalli Beach.",
          "Return to your hotel and pack up your bags to get ready to fly to the islands tomorrow.",
        ],
      },
      {
        day: "06",
        title: "JEJU: ARRIVAL AND LEISURE DAY",
        details: [
          "On arrival at Jeju, check in to the hotel and relax in your room.",
          "Enjoy the day at leisure.",
          "Stay overnight for a good sleep.",
        ],
      },
      {
        day: "07",
        title: "JEJU: SIGHTSEEING",
        details: [
          "It is time to leave the hotel and head to see horses.",
          "Different breeds of horses are found here.",
          "Horse riding here is exciting and it makes you feel closer to the animals.",
          "Take pictures with the horses and spend some time here.",
          "Soothe your taste buds at a local restaurant.",
          "When we talk of Jeju, one thing that needs special mention are the women divers.",
          "Take pictures with these brave women who spend so much time in the chilled water.",
          "The Seongeup Folk showcases the Jeju village culture.",
          "Do not forget to visit Manjanggul which consists of lava tube tunnels and other strange structures.",
          "Reach the pick up point and wait for the bus to escort you to your hotel.",
        ],
      },
      {
        day: "08",
        title: "DEPARTURE",
        details: [
          "Post breakfast, check out from the hotel and contact your driver.",
          "He will escort you to the airport.",
          "Proceed towards your destination with memories to cherish for eternity.",
        ],
      },
    ],
    inclusions: [
      "Return Airfare and Airport taxes from Bangalore in Economy Class",
      "07 Nights in hotels mentioned below",
      "All transfers as per the itinerary on SIC BASIS",
      "Continental Breakfasts",
      "All sightseeing as mentioned in the Itinerary",
      "Overseas Travel Insurance",
      "Domestic Flights",
      "All tips, road tolls, and taxes at the destination included",
      "Applicable GST",
    ],
    exclusions: [
      "Any other services not mentioned under inclusions",
      "Lunch & Dinner",
      "Porterage",
    ],
  },
  // 4. South Korea Tour 7N/8D
  {
    id: 4,
    title: "South Korea Highlights",
    subtitle: "SEOUL - JEJU",
    image: sk2,
    images: [sk1, sk2, sk3, sk4, sk5, sk6],
    overview:
      " South Korea offers a rich blend of ancient traditions andcutting-edge modern life. Experience historic palaces, traditional Hanok villages, and age-old customs rooted in Confucian and Buddhist culture. Witness colorful festivals, traditional Hanbok attire, and classical performances like Samulnori and Taekwondo. Savor authentic Korean cuisine shaped by centuries of heritage, from kimchi to royal court dishes. With warm hospitality and deep cultural pride, South Korea delivers a meaningful and immersive travel experience. 🇰🇷",
    duration: "6 Nights / 7 Days",
    itinerary: [
      {
        day: "DAY 1",
        title: "SEOUL: ARRIVAL AND LEISURE DAY",
        details: [
          "On arrival, meet our representatives and head to the hotel.",
          "Spend the day at your leisure and have a good night’s sleep.",
        ],
      },
      {
        day: "DAY 2",
        title: "SEOUL: SIGHTSEEING",
        details: [
          "Explore the culture of Korea and end the day with some shopping to fill your heart.",
          "Grab a delicious meal of breakfast at the hotel, get ready for the day and proceed for some sightseeing.",
          "Go to places like the Blue House and President’s House.",
          "Next, proceed to the Jogyesa Buddhist temple, one of the most prominent tourist spots in Korea.",
          "Admire the trees at the entrance and enter the temple, 500 years old.",
          "Next is the Gyeongbokgung Palace that showcases royalty.",
          "Let the guide unveil the beauty of the palace for you.",
          "After this fill your tummies with tasty Korean lunch before heading to Changdeokgung Palace.",
          "The massive gates, the gigantic building enthralls you.",
          "Wander down to markets, local restaurants and other places of interest.",
        ],
      },
      {
        day: "DAY 3",
        title: "SEOUL: FULL-DAY TOUR TO NAMI ISLAND AND PETITE FRANCE",
        details: [
          "A stroll in the countryside accompanied by sightseeing at the Nami Island.",
          "The popularity explosion of Korean pop culture has spread across Southeast Asia, and with this tour, you get to experience it for yourself.",
          "Visit the major filming sites and live the ever-growing Korean Wave.",
          "Nami Island is one of the most famous islands in South Korea for being the filming location of the TV drama “Winter Sonata”.",
          "Visiting this place is a must.",
          "Do not forget to visit Petite France and the Garden of Morning Calm.",
          "End the tour with a shopping stroll in the market.",
          "Stay overnight in the hotel.",
        ],
      },
      {
        day: "DAY 4",
        title: "JEJU: ARRIVAL AND LEISURE DAY",
        details: [
          "Time to make your sojourn a bit more memorable",
          "On arrival at Jeju, check in to the hotel and relax in your room.",
          "Enjoy the day at leisure.",
          "Stay overnight for a good sleep.",
        ],
      },
      {
        day: "DAY 5",
        title: "JEJU: SIGHTSEEING",
        details: [
          "Connect with the beauty of nature in gardens, islands and appreciate the music in Korea",
          "Head to Hyeopjae Beach is one of the popular places that many tourists visit anytime.",
          "The white sand beach is a major spot of attraction for the tourists.",
          "Visit the Hallim Park to witness a variety of gardens.",
          "It is indeed a breath-taking view.",
          "Proceed to the O'sulloc Museum where you can learn about the traditional Korean tea.",
          "For lunch, go for traditional Korean Jeju Local Well-being Buffet.",
          "You could head to the Sanbang Mountain for a lovely view.",
          "Brother Seashore Road unveils a small village, and traveling a certain distance from here leads you to a beautiful sea that has a marvelous view.",
          "Enjoy the pop culture music in Korea.",
        ],
      },
      {
        day: "DAY 6",
        title: "JEJU: SIGHTSEEING",
        details: [
          "Cherish the history of this place and enjoy sumptuous meals.",
          "It is time to leave the hotel and head to see horses.",
          "Different breeds of horses are found here.",
          "Horse riding here is exciting and it makes you feel closer to the animals.",
          "Take pictures with the horses and spend some time here.",
          "Soothe your taste buds at a local restaurant.",
          "When we talk of Jeju, one thing that needs special mention are the women divers.",
          "Take pictures with these brave women who spend so much time in the chilled water.",
          "Hats-off to them!",
          "The Seongeup Folk showcases the Jeju village culture.",
          "not forget to visit Manjanggul which consists of lava tube tunnels and other strange structures.",
          "Your pick up will be exactly where you had been dropped off.",
          "Reach that place and wait for the bus to arrive and escort you to your hotel.",
        ],
      },
      {
        day: "DAY 7",
        title: "DEPARTURE",
        details: [
          "The trip comes to an end on a good note.",
          "Post breakfast, check out from the hotel and contact your diver.",
          "He will escort you to the airport.",
          "Proceed towards your destination with memories to cherish for eternity.",
        ],
      },
    ],
    inclusions: [
      "Return Airfare and Airport taxes from Bangalore in Economy Class",
      "06 Nights in hotels mentioned below",
      "All transfers as per the itinerary on SIC BASIS",
      "Continental Breakfasts",
      "All sightseeing as mentioned in the Itinerary",
      "Overseas Travel Insurance",
      "Domestic Flights",
      "All tips, road tolls, and taxes at the destination included",
      "Applicable GST",
    ],
    exclusions: [
      "Any other services not mentioned under inclusions",
      "Lunch & Dinner",
      "Porterage",
    ],
  },
  // 5. Italy Tour
  {
    id: 5,
    title: "Prestige Italy",
    subtitle: "Experience the Vibrant Culture of Italy",
    image: italy1,
    images: [italy1, italy2, italy3, italy4, italy5, italy6],
    overview:
      " South Korea offers a rich blend of ancient traditions andcutting-edge modern life. Experience historic palaces, traditional Hanok villages, and age-old customs rooted in Confucian and Buddhist culture. Witness colorful festivals, traditional Hanbok attire, and classical performances like Samulnori and Taekwondo. Savor authentic Korean cuisine shaped by centuries of heritage, from kimchi to royal court dishes. With warm hospitality and deep cultural pride, South Korea delivers a meaningful and immersive travel experience. 🇰🇷",
    duration: "5 Days / 6 Nights",
    itinerary: [
      {
        day: 1,
        title: "Arrival in Denpasar",
        details: [
          "Check into Seminyak, relaxing evening.",
          "Check into Seminyak, relaxing evening.",
        ],
      },

      {
        day: 2,
        title: "Ubud Culture Tour",
        details: "Visit Tegalalang Rice Terraces and Monkey Forest.",
      },
      {
        day: 3,
        title: "Beach Day",
        details: "Explore Kuta and Seminyak beaches.",
      },
      {
        day: 4,
        title: "Temple Visit",
        details: "Tour Uluwatu Temple at sunset.",
      },
      {
        day: 5,
        title: "Water Sports",
        details: "Snorkeling or diving near Nusa Dua.",
      },
      {
        day: 6,
        title: "Free Day / Shopping",
        details: "Explore local markets and enjoy a spa session.",
      },
      {
        day: 7,
        title: "Departure",
        details: "Transfer to Denpasar International Airport.",
      },
    ],
    inclusions: [
      "Accommodation in 4-star hotels",
      "Daily breakfast",
      "Airport transfers",
      "Guided tours as per itinerary",
      "All entrance fees",
    ],
    exclusions: [
      "International airfare",
      "Travel insurance",
      "Personal expenses",
      "Meals not mentioned in inclusions",
    ],
  },
  // 6. Greece Tour 6N/7D
  {
    id: 6,
    title: "Timeless Greece",
    subtitle: "Experience the Vibrant Culture of Greece",
    image: greece1,
    images: [greece1, greece2, greece3, greece4, greece5, greece6],
    overview:
      " Discover Greece, a timeless destination where ancient civilizations, mythology, and modern charm come together. Walk through world-famous historical sites like the Acropolis of Athens, Delphi, and ancient ruins that shaped Western history. Unwind on picturesque islands such as Santorini, Mykonos, and Crete, known for whitewashed villages, blue seas, and golden beaches. Savor authentic Greek cuisine, lively local markets, traditional music, and warm Mediterranean hospitality. From romantic sunsets and scenic coastlines to rich culture and history, Greece offers a truly unforgettable travel experience. 🇬🇷",
    duration: "6 Nights / 7 Days",
    itinerary: [
      {
        day: "01",
        title: "BANGALORE – ATHENS",
        details: [
          [
            "On arrival in Athens",
            " ",
            <strong>M D Tours & Travels</strong>,
            " ",
            "representative will be waiting at the airport to take you to hotel.",
          ],
          "Check in at hotel.",
          "Later in the Evening, we proceed for Athens by Night Tour (Group)",
          "After night tour return back to Hotel and Overnight at hotel, Athens",
          "Later in the evening, go on an Athens by Night tour for a sumptuous Dinner and Folk Show.",
          "Visit the main Greek port of Piraeus, passing by the most important points of the city (City Hall, picturesque yachts harbor of Microlimano).",
          "Following the principal avenues and passing by the Temple of Olympian Zeus, National Garden, Parliament, Tomb of the Unknown Soldier, Catholic Cathedral, Academy, University, National Library, Old Parliament, and then arrive at Plaka.",
          "Take a short pleasant walk through the old unique Athens city to one of the popular taverns for dinner with live bouzouki music and Greek folk dances.",
          [
            <strong>
              (Operates only on Tuesday, Wednesday, Thursday and Saturday)
            </strong>,
          ],
        ],
      },
      {
        day: "02",
        title: "ATHENS – AFTERNOON HALF DAY ATHENS WITH ACROPOLIS",
        details: [
          "Breakfast at Hotel",
          "Morning day for the leisure – Your own time",
          "Later in the Afternoon, proceed to Half day Athens tour with Acropolis",
          "After tour return back to Hotel and Overnight at hotel, Athens",
          "This tour gives you an opportunity to observe the striking contrasts that make Athens such a fascinating city.",
          "Our expert guide will take you to see the centre of the city including Constitution Square (Syntagma), the House of Parliament, the Memorial to the Unknown Soldier and the National Library.",
          "Driving down Herod Atticus Street you will see the Evzones in their picturesque uniform and the presidential Palace.",
          "On your way to the Acropolis you will see the Hadrian's Arch, visit the Temple of Olympian Zeus and you will make a short stop at the Panathenaic Stadium where the first Olympic Games of the modern era were held in 1896.",
          "On the Acropolis visit the architectural masterpieces of the Golden Age of Athens; the Propylaea, the Temple of Athena Nike, The Erectheion and finally the Parthenon.",
        ],
      },
      {
        day: "03",
        title: "ATHENS – MYKONOS BY FERRY",
        details: [
          "Breakfast at Hotel",
          "Check out from hotel and proceed to Pier",
          "Board the ferry to Mykonos.",
          "On arrival, transfer to Hotel in Mykonos.",
          "Check in at hotel",
          "Rest of the day for leisure – Explore Island your own",
          "Overnight stay at Hotel, Mykonos",
          "Mykonos Island, the cosmopolitan jewel of the Aegean Sea, is one of the prime holiday destinations in the world.",
          "Magnificent beaches, picturesque whitewashed villages, charming cafes and bars by the seafront, and some of the most beautiful views in the Cyclades Islands.",
          "The rest of the day is yours to explore the most famous of the Cycladic Islands on your own.",
        ],
      },
      {
        day: "04",
        title: "DELOS GUIDED TOUR FROM MYKONOS",
        details: [
          "Breakfast at Hotel",
          "Later proceed to Full Day Delos Guided Tour",
          "After day tour return back to Hotel and Overnight at hotel, Mykonos",
          "You will meet at Mykonos Old Port to board your boat and enjoy your 45 minutes cruise to Delos.",
          "Delos is one of the most sacred sites in Greece.",
          "It was the center of the Cyclades islands in the ancient world and the birthplace of the Greek gods Apollo and Artemis.",
          "Inhabited between 2,500 and 69 BC, Delos boasts many antique treasures such as the Agora, the Terrace of the Naxos Lions and the Sacred Lake.",
          "Exploring the houses of Dionysus, Cleopatra, the Trident, the Masks and the Dolphins, with their beautiful mosaics.",
          "Explore the Temple of Isis, the Egyptian Goddess, the Roman water system, the cisterns and much more.",
        ],
      },
      {
        day: "05",
        title: "MYKONAS – SANTORINI BY FERRY",
        details: [
          "Breakfast at Hotel",
          "Check out from hotel and proceed to Pier",
          "Board the ferry to Santorini",
          "On arrival, transfer to Hotel in Santorini.",
          "Check in at hotel",
          "Rest of the day for leisure – Explore Island your own",
          "Overnight stay at Hotel, Santorini",
          "Crescent-shaped Santorini is perhaps the most fascinating island of Greece.",
          "Volcanic landscape, gray and red beaches, dazzling white houses, terraces with panoramic sea views and stunning sunsets.",
        ],
      },
      {
        day: "06",
        title: "FULL DAY VOLCANO TOUR AND HOT SPRINGS FROM SANTORINI",
        details: [
          "Breakfast at Hotel",
          "Proceed to Full day Volcano Tour and Hot Springs",
          "After day tour return back to Hotel and Overnight at hotel, Santorini",
          "Depart from your pickup point to Athinios Port.",
          "Sail to the Volcano and explore this natural landmark.",
          "Sail to the Hot Springs and swim to the warm waters.",
          "Return to Scala port where the buses will be waiting for return journey.",
        ],
      },
      {
        day: "07",
        title: "SANTORINI – ATHENS BY FERRY AND DEPARTURE FLIGHT",
        details: [
          "Breakfast at Hotel",
          "Check out Hotel and Proceed to Pier",
          "Board the Ferry to Athens",
          "On arrival, transfer to Athens Airport by road",
          "Drop Off at Athens Airport",
          "Tour Ends.",
        ],
      },
    ],
    inclusions: [
      "02 Night Accommodation with Breakfast in Athens (except on the day of arrival)",
      "02 Night Accommodation with Breakfast in Mykonos",
      "02 Night Accommodation with Breakfast in Santorini",
      "Return Airport and Port transfers in Athens on Private Basis",
      "All other transfer and sightseeing as mentioned in the itinerary on Seat in Coach Basis",
      "Athens by Night Tour",
      "Half day Afternoon Athens tour with Acropolis",
      "Full Day Delos Guided Tour from Mykonos",
      "Full day Volcano Tour and Hot Springs from Santorini",
      "Services of English-Speaking guide",
      "Ferry tickets (Athens to Mykonos to Santorini to Athens)",
      "International Air Tickets",
      "Airport Taxes",
      "Govt. Service Tax of 5.00% payable to Govt of India",
      "Visa Charges",
    ],
    exclusions: [
      "Overseas Medical Insurance.",
      "Lunch & Dinner",
      "City Tax payable at the time of check-out.",
      "Meals, Tips, Laundry, telephone, optional excursions and other items of a personal nature.",
      "Cost of foreign exchange for personal use.",
      "Any items or services not specified in the itinerary 'PACKAGE INCLUDES' head.",
    ],
  },
  // 7. Greece Tour 7N/8D
  {
    id: 7,
    title: "Greece Opulence",
    subtitle: "Experience the Vibrant Culture of Greece",
    image: greece2,
    images: [greece1, greece2, greece3, greece4, greece5, greece6],
    overview:
      " Discover Greece, a timeless destination where ancient civilizations, mythology, and modern charm come together. Walk through world-famous historical sites like the Acropolis of Athens, Delphi, and ancient ruins that shaped Western history. Unwind on picturesque islands such as Santorini, Mykonos, and Crete, known for whitewashed villages, blue seas, and golden beaches. Savor authentic Greek cuisine, lively local markets, traditional music, and warm Mediterranean hospitality. From romantic sunsets and scenic coastlines to rich culture and history, Greece offers a truly unforgettable travel experience. 🇬🇷",
    duration: "7 Nights / 8 Days",
    itinerary: [
      {
        day: "01",
        title: "BANGALORE – ATHENS",
        details: [
          [
            "On arrival in Athens",
            " ",
            <strong>M D Tours & Travels</strong>,
            " ",
            "representative will be waiting at the airport to take you to hotel.",
          ],
          "Check in at hotel.",
          "Later in the Evening, we proceed for Athens by Night Tour (Group)",
          "After night tour return back to Hotel and Overnight at hotel, Athens",
          "Later in the evening, go on an Athens by Night tour for a sumptuous Dinner and Folk Show.",
          "Visit the main Greek port of Piraeus, passing by the most important points of the city (City Hall, picturesque yachts harbor of Microlimano).",
          "Following the principal avenues and passing by the Temple of Olympian Zeus, National Garden, Parliament, Tomb of the Unknown Soldier, Catholic Cathedral, Academy, University, National Library, Old Parliament, and then arrive at Plaka.",
          "Take a short pleasant walk through the old unique Athens city to one of the popular taverns for dinner with live bouzouki music and Greek folk dances.",
          [
            <strong>
              (Operates only on Tuesday, Wednesday, Thursday and Saturday)
            </strong>,
          ],
        ],
      },
      {
        day: "02",
        title: "ATHENS – AFTERNOON HALF DAY ATHENS WITH ACROPOLIS",
        details: [
          "Breakfast at Hotel",
          "Morning day for the leisure – Your own time",
          "Later in the Afternoon, proceed to Half day Athens tour with Acropolis",
          "After tour return back to Hotel and Overnight at hotel, Athens",
          "This tour gives you an opportunity to observe the striking contrasts that make Athens such a fascinating city.",
          "Our expert guide will take you to see the centre of the city including Constitution Square (Syntagma), the House of Parliament, the Memorial to the Unknown Soldier and the National Library.",
          "Driving down Herod Atticus Street you will see the Evzones in their picturesque uniform and the presidential Palace.",
          "On your way to the Acropolis you will see the Hadrian's Arch, visit the Temple of Olympian Zeus and you will make a short stop at the Panathenaic Stadium where the first Olympic Games of the modern era were held in 1896.",
          "On the Acropolis visit the architectural masterpieces of the Golden Age of Athens; the Propylaea, the Temple of Athena Nike, The Erectheion and finally the Parthenon.",
        ],
      },
      {
        day: "03",
        title: "ATHENS – MYKONOS BY FERRY",
        details: [
          "Breakfast at Hotel",
          "Check out from hotel and proceed to Pier",
          "Board the ferry to Mykonos.",
          "On arrival, transfer to Hotel in Mykonos.",
          "Check in at hotel",
          "Rest of the day for leisure – Explore Island your own",
          "Overnight stay at Hotel, Mykonos",
          "Mykonos Island, the cosmopolitan jewel of the Aegean Sea, is one of the prime holiday destinations in the world.",
          "Magnificent beaches, picturesque whitewashed villages, charming cafes and bars by the seafront, and some of the most beautiful views in the Cyclades Islands.",
          "The rest of the day is yours to explore the most famous of the Cycladic Islands on your own.",
        ],
      },
      {
        day: "04",
        title: "DELOS GUIDED TOUR FROM MYKONOS",
        details: [
          "Breakfast at Hotel",
          "Later proceed to Full Day Delos Guided Tour",
          "After day tour return back to Hotel and Overnight at hotel, Mykonos",
          "You will meet at Mykonos Old Port to board your boat and enjoy your 45 minutes cruise to Delos.",
          "Delos is one of the most sacred sites in Greece.",
          "It was the center of the Cyclades islands in the ancient world and the birthplace of the Greek gods Apollo and Artemis.",
          "Inhabited between 2,500 and 69 BC, Delos boasts many antique treasures such as the Agora, the Terrace of the Naxos Lions and the Sacred Lake.",
          "Exploring the houses of Dionysus, Cleopatra, the Trident, the Masks and the Dolphins, with their beautiful mosaics.",
          "Explore the Temple of Isis, the Egyptian Goddess, the Roman water system, the cisterns and much more.",
        ],
      },
      {
        day: "05",
        title: "MYKONAS – SANTORINI BY FERRY",
        details: [
          "Breakfast at Hotel",
          "Check out from hotel and proceed to Pier",
          "Board the ferry to Santorini",
          "On arrival, transfer to Hotel in Santorini.",
          "Check in at hotel",
          "Rest of the day for leisure – Explore Island your own",
          "Overnight stay at Hotel, Santorini",
          "Crescent-shaped Santorini is perhaps the most fascinating island of Greece.",
          "Volcanic landscape, gray and red beaches, dazzling white houses, terraces with panoramic sea views and stunning sunsets.",
        ],
      },
      {
        day: "06",
        title: "FULL DAY VOLCANO TOUR AND HOT SPRINGS FROM SANTORINI",
        details: [
          "Breakfast at Hotel",
          "Proceed to Full day Volcano Tour and Hot Springs",
          "After day tour return back to Hotel and Overnight at hotel, Santorini",
          "Depart from your pickup point to Athinios Port.",
          "Sail to the Volcano and explore this natural landmark.",
          "Sail to the Hot Springs and swim to the warm waters.",
          "Return to Scala port where the buses will be waiting for return journey.",
        ],
      },
      {
        day: "07",
        title: "SANTORINI – ATHENS BY FERRY AND DEPARTURE FLIGHT",
        details: [
          "Breakfast at Hotel",
          "Check out Hotel and Proceed to Pier",
          "Board the Ferry to Athens",
          "On arrival, transfer to Athens Airport by road",
          "Drop Off at Athens Airport",
          "Tour Ends.",
        ],
      },
    ],
    itinerary: [
      {
        day: "DAY 01",
        title: "BANGALORE – ATHENS",
        details: [
          [
            "On arrival in Athens",
            " ",
            <strong>M D Tours & Travels</strong>,
            " ",
            "representative will be waiting at the airport to take you to hotel.",
          ],
          "Check in at hotel.",
          "Later in the Evening, we proceed for Athens by Night Tour (Group)",
          "After night tour return back to Hotel and Overnight at hotel, Athens",
          "Later in the evening, go on an Athens by Night tour for a sumptuous Dinner and Folk Show.",
          "Visit the main Greek port of Piraeus, passing by the most important points of the city (City Hall, picturesque yachts harbor of Microlimano).",
          "Following the principal avenues and passing by the Temple of Olympian Zeus, National Garden, Parliament, Tomb of the Unknown Soldier, Catholic Cathedral, Academy, University, National Library, Old Parliament, and then arrive at Plaka.",
          "Take a short pleasant walk through the old unique Athens city to one of the popular taverns for dinner with live bouzouki music and Greek folk dances.",
          "(Operates only on Tuesday, Wednesday, Thursday and Saturday)",
        ],
      },
      {
        day: "DAY 02",
        title: "ATHENS – MYKONOS BY FERRY",
        details: [
          "Breakfast at Hotel",
          "Check out from hotel and proceed to Pier",
          "Board the ferry to Mykonos.",
          "On arrival, transfer to Hotel in Mykonos.",
          "Check in at hotel",
          "Rest of the day for leisure – Explore Island your own",
          "Overnight stay at Hotel, Mykonos",
          "Mykonos Island, the cosmopolitan jewel of the Aegean Sea, is one of the prime holiday destinations in the world.",
          "Magnificent beaches, picturesque whitewashed villages, charming cafes and bars by the seafront, and some of the most beautiful views in the Cyclades Islands.",
          "The rest of the day is yours to explore the most famous of the Cycladic Islands on your own.",
        ],
      },
      {
        day: "DAY 03",
        title: "DELOS GUIDED TOUR FROM MYKONOS",
        details: [
          "Breakfast at Hotel",
          "Later proceed to Full Day Delos Guided Tour",
          "After day tour return back to Hotel and Overnight at hotel, Mykonos",
          "You will meet at Mykonos Old Port to board your boat and enjoy your 45 minutes cruise to Delos.",
          "Delos is one of the most sacred sites in Greece.",
          "It was the center of the Cyclades islands in the ancient world and the birthplace of the Greek gods Apollo and Artemis.",
          "Inhabited between 2,500 and 69 BC, Delos boasts many antique treasures, such as the Agora (ancient market place), the famous Terrace of the Naxos Lions and the Sacred Lake.",
          "See the living quarters and theater that provide visitors to Delos with a unique vision of daily life in Ancient Greece.",
          "Exploring the houses of Dionysus, Cleopatra, the Trident, the Masks and the Dolphins, with their beautiful mosaics.",
          "Explore the Temple of Isis, the Egyptian Goddess, the Roman water system, the fascinating cisterns and much more.",
        ],
      },
      {
        day: "DAY 04",
        title: "MYKONOS – SANTORINI BY FERRY",
        details: [
          "Breakfast at Hotel",
          "Check out from hotel and proceed to Pier",
          "Board the ferry to Santorini",
          "On arrival, transfer to Hotel in Santorini.",
          "Check in at hotel",
          "Rest of the day for leisure – Explore Island your own",
          "Overnight stay at Hotel, Santorini",
          "Crescent-shaped Santorini (or Thira), the precious gem of the Aegean is perhaps the most fascinating and most talked about island of Greece in the Aegean.",
          "Volcanic landscape, gray and red beaches, dazzling white houses, terraces with panoramic sea views and stunning sunsets.",
        ],
      },
      {
        day: "DAY 05",
        title: "FULL DAY VOLCANO TOUR AND HOT SPRINGS FROM SANTORINI",
        details: [
          "Breakfast at Hotel",
          "Proceed to Full day Volcano Tour and Hot Springs",
          "After day tour return back to Hotel and Overnight at hotel, Santorini",
          "Depart from your pickup point to Athinios Port, where you will embark the caique with your guide and sail to the Volcano.",
          "Explore this natural landmark and for those feeling energetic there is the possibility of walking up the volcano face with your guide (entrance not included).",
          "The caique then sails to the Hot Springs and stops (but does not dock), giving you the chance to dive into the sea and swim to the warm waters of the Hot Springs.",
          "Finally, we will return to Scala port where the buses will be waiting for you for your return journey.",
        ],
      },
      {
        day: "DAY 06",
        title: "FREE DAY AT SANTORINI",
        details: [
          "Breakfast at Hotel",
          "Free day at leisure for exploring the city.",
          "Overnight stay at Hotel, Santorini",
        ],
      },
      {
        day: "DAY 07",
        title: "SANTORINI – ATHENS BY FERRY AND FREE DAY AT LEISURE",
        details: [
          "Breakfast at Hotel",
          "Check out Hotel and Proceed to Pier",
          "Board the Ferry to Athens",
          "On arrival, transfer to Athens and free day at leisure.",
        ],
      },
      {
        day: "DAY 08",
        title: "ATHENS- FLY TO INDIA",
        details: [
          "Breakfast at Hotel",
          "Check out Hotel and Proceed to Athens Airport",
          "Fly to India",
          "Tour Ends.",
        ],
      },
    ],
    inclusions: [
      "02 Night Accommodation with Breakfast in Athens (except on the day of arrival)",
      "02 Night Accommodation with Breakfast in Mykonos",
      "03 Night Accommodation with Breakfast in Santorini",
      "Return Airport and Port transfers in Athens on Private Basis",
      "All other transfer and sightseeing as mentioned in the itinerary on Seat in Coach Basis",
      "Athens by Night Tour",
      "Half day Afternoon Athens tour with Acropolis",
      "Full Day Delos Guided Tour from Mykonos",
      "Full day Volcano Tour and Hot Springs from Santorini",
      "Services of English-Speaking guide",
      "Ferry tickets (Athens to Mykonos to Santorini to Athens)",
      "International Air Tickets",
      "Airport Taxes",
      "Govt. Service Tax of 5.00% payable to Govt of India",
      "Visa Charges",
    ],
    exclusions: [
      "Overseas Medical Insurance.",
      "City Tax payable at the time of check-out.",
      "Meals, Tips, Laundry, telephone, optional excursions and other items of a personal nature.",
      "Cost of foreign exchange for personal use.",
      "Any items or services not specified in the itinerary 'PACKAGE INCLUDES' head.",
    ],
  },
  // 5. France Tour
  {
    id: 5,
    title: "France Tour",
    subtitle: "Experience the Vibrant Culture of France",
    image: france1,
    images: [france1, france2, france3, france4],
    overview:
      " South Korea offers a rich blend of ancient traditions andcutting-edge modern life. Experience historic palaces, traditional Hanok villages, and age-old customs rooted in Confucian and Buddhist culture. Witness colorful festivals, traditional Hanbok attire, and classical performances like Samulnori and Taekwondo. Savor authentic Korean cuisine shaped by centuries of heritage, from kimchi to royal court dishes. With warm hospitality and deep cultural pride, South Korea delivers a meaningful and immersive travel experience. 🇰🇷",
    duration: "5 Days / 6 Nights",
    itinerary: [
      {
        day: 1,
        title: "Arrival in Denpasar",
        details: [
          "Check into Seminyak, relaxing evening.",
          "Check into Seminyak, relaxing evening.",
        ],
      },

      {
        day: 2,
        title: "Ubud Culture Tour",
        details: "Visit Tegalalang Rice Terraces and Monkey Forest.",
      },
      {
        day: 3,
        title: "Beach Day",
        details: "Explore Kuta and Seminyak beaches.",
      },
      {
        day: 4,
        title: "Temple Visit",
        details: "Tour Uluwatu Temple at sunset.",
      },
      {
        day: 5,
        title: "Water Sports",
        details: "Snorkeling or diving near Nusa Dua.",
      },
      {
        day: 6,
        title: "Free Day / Shopping",
        details: "Explore local markets and enjoy a spa session.",
      },
      {
        day: 7,
        title: "Departure",
        details: "Transfer to Denpasar International Airport.",
      },
    ],
    inclusions: [
      "Accommodation in 4-star hotels",
      "Daily breakfast",
      "Airport transfers",
      "Guided tours as per itinerary",
      "All entrance fees",
    ],
    exclusions: [
      "International airfare",
      "Travel insurance",
      "Personal expenses",
      "Meals not mentioned in inclusions",
    ],
  },
  //BALI 5N / 6D
  {
    id: 5,
    title: "Bali Bliss",
    subtitle:
      "Agatti Island - Soutn Beach - Baangaram Thinakara Island - Shallow Lagoon - Sandy Beach",
    image: bali1,
    images: [bali1, bali2, bali3, bali4, bali5, bali6],
    overview:
      " Bali is a tropical paradise known for its stunning beaches, lush rice terraces, and vibrant culture. The island offers a perfect blend of luxury resorts, spiritual temples, and scenic natural beauty. Visitors can explore iconic spots like Uluwatu Temple, Ubud, and the beautiful Nusa Islands. Bali is also famous for its wellness retreats, traditional Balinese massages, and yoga experiences. Adventure seekers can enjoy water sports, volcano trekking, and jungle activities. With warm hospitality, rich traditions, and breathtaking sunsets, Bali promises an unforgettable holiday experience. 🇮🇩",
    duration: "5 Nights / 6 Days",
    itinerary: [
      {
        day: "01",
        title: "ARRIVAL AGATTI ISLAND",
        details: [
          "On arrival at Agatti airport, our representative will receive and escort you to the Hotel.",
          "After the lunch proceed for Agatti island sightseeing which include – Public Library, anthropological museum, South beach, Eastern jetty (ship embarkation and disembarkation point), NIOT sea water desalination Plant, Lagoon beach a sunset point, relax in the creamy sand for a couple of hours and back to Hotel around 7:00 pm, dinner will be serve at 8:30 pm.",
          "Overnight stay at Agatti.",
        ],
      },
      {
        day: "02",
        title: "AGATTI – SOUTH BEACH FOR WATER SPORTS ACTIVITIES",
        details: [
          "Morning after breakfast proceed to South Beach, nonstop water sports available at the beach, like swimming, snorkeling, kayaking, well equipped SCUBA diving center working at beach which offers Snorkeling, Kayaking, Diving, Glass bottom boat ride on payment.",
          "Guidance of well experienced diving instructor you can enjoy the underwater beauty.",
          "Lunch will be served at the beach on request.",
          "After 4 PM back to Hotel / and relax Hotel/ round, relax in room, dinner will be served at 8:30.",
          "Overnight stay at Agatti.",
        ],
      },
      {
        day: "03",
        title: "AGATTI – BANGARAM  THINAKARA ISLAND DAY TRIP BY PRIVATE BOAT",
        details: [
          "Early morning after breakfast proceeds to Bangaram group of islands beautiful uninhabited island , Bangaram, Tinnakara island , in a single atoll, lying in the northern side of Agatti.",
          "Tour by a private boat from Agatti 45 minutes Journey.",
          "Trip provides beautiful sandy beaches and swimming with turtles, snorkeling in blue shallow water.",
          "After Bangaram sightseeing, boat moves to Thinnakara island , after 5 pm boat moves to Agatti Hotel, relax in room, dinner will be served at 8:30 pm.",
          "Please note movement of the boat to Thinnakara depends on high tide and low tide of sea level",
          "Overnight stay at Agatti.",
        ],
      },
      {
        day: "04",
        title: "ACTIVITIES IN SHALLOW LAGOON",
        details: [
          "After Morning breakfast, enjoy the Glass bottom boating in the lagoon for 1 hour, nonstop water sports available at the beach, like swimming, snorkelling, kayaking up to 12 PM.",
          "Lunch will be served at 1 PM.",
          "After 4:30 pm proceed to Kalpitti island , a small islet in the southern tip of Agatti , which offer swimming and turtle watch, The journey by a small boat in shallow water, sightseeing in the island by walk, after sightseeing Kalpitti island return to Agatti around 6:30 pm.",
          "Overnight stay at Agatti.",
        ],
      },
      {
        day: "05",
        title: "ENJOY THE SANDY BEACH BAREFOOT WALK",
        details: [
          "Enjoy the sandy beach barefoot walk and leisure time at Agatti.",
          "Check out and proceed to Agatti Airport for your return flight.",
          "Tour Ends.",
        ],
      },
    ],
    inclusions: [
      "04 Nights Accommodation",
      "Daily Breakfast",
      "All transfers as per the itinerary",
      "Sightseeing as per the itinerary",
      "Local guide services at Islands",
      "Ferry/Boat transfers as mentioned",
    ],
    exclusions: [
      "Lunch",
      "Personal Expenses",
      "Water Sports charges where applicable",
      "Any other services not mentioned in inclusions",
    ],
  },
  // 6. Maldives Tour
  {
    id: 6,
    title: "Maldives Serenity",
    subtitle: "Adaaran Club Rannalhi",
    image: maldives1,
    images: [maldives1, maldives2, maldives3, maldives4, maldives5],
    overview:
      " The Maldives is a tropical paradise famous for its turquoise lagoons and pristine white-sand beaches. Stay in luxurious overwater villas offering privacy and breathtaking ocean views. Enjoy snorkeling and diving among vibrant coral reefs and marine life. Relax with world-class spa treatments and serene island surroundings. Experience romantic sunsets, candlelight dinners, and floating breakfasts. A Maldives tour promises ultimate relaxation, luxury, and unforgettable memories. 🇲🇻",
    duration: "5 Days / 6 Nights",
    itinerary: [
      {
        day: "01",
        title: "MALDIVES AIRPORT TO RESORT",
        details: [
          "Upon arrival at the Maldives Airport, you will be met by our local representative for your transfer to the hotel.",
          "After check in at the hotel rest of the day is at leisure.",
          "Overnight at the hotel in Male.",
          "MEALS: DINNER + DRINKS",
        ],
      },
      {
        day: "02",
        title: "MALDIVES",
        details: [
          "Enjoy your day at leisure.",
          "Overnight at the hotel in Male.",
          "MEALS: BREAKFAST + LUNCH + DINNER + DRINKS",
        ],
      },
      {
        day: "03",
        title: "MALDIVES",
        details: [
          "Enjoy your day at leisure.",
          "Overnight at the hotel in Male.",
          "MEALS: BREAKFAST + LUNCH + DINNER + DRINKS",
        ],
      },
      {
        day: "04",
        title: "MALIDIVES",
        details: [
          "Enjoy your day at leisure.",
          "Overnight at the hotel in Male.",
          "MEALS: BREAKFAST + LUNCH + DINNER + DRINKS",
        ],
      },
      {
        day: "05",
        title: "DEPARTURE",
        details: [
          "Check out from the Hotel and Proceed to Male Airport by Speed Boat",
          "End of Service.",
          "MEALS: BREAKFAST + DRINKS",
        ],
      },
    ],
    inclusions: [
      "04 Night Accommodation",
      "Meals All Inclusive Basis (Breakfast + Lunch + Dinner + Drinks)",
      "Return Airport Transfers by Speed Boat",
      "Hotel Taxes",
      "Green Taxes",
      "Honeymoon Benefits (Will advise)",
      "Travel Insurance",
      "Round Flight Fares Inclusive of Taxes",
      "GST and TCS",
    ],
    exclusions: [
      "PCR Test (Pay at property)",
      "Cost of Meals other than those specified in inclusions",
      "Cost of any other services not specifically mentioned in inclusions",
    ],
  },
  // 7. Singapore Tour
  {
    id: 12,
    title: "Spectacular Singapore",
    subtitle: "Singapore City",
    image: singapore1,
    images: [singapore1, singapore2, singapore3, singapore4],
    overview: [
      [
        "Singapore is a vibrant island nation known for its futuristic skyline, world-class attractions, lush green spaces, and rich multicultural heritage. From iconic landmarks like Marina Bay Sands and Merlion Park to thrilling experiences at Sentosa Island, Singapore offers a perfect blend of modern luxury, entertainment, and cultural charm. Its clean streets, efficient transport, and diverse cuisine make it one of Asia’s most sought-after travel destinations.🇸🇬",
      ],
    ],
    duration: "4 Nights / 5 Days",
    itinerary: [
      {
        day: "01",
        title: "ARRIVAL IN SINGAPORE",
        details: [
          "Arrived in Singapore",
          " Meet and Greet at Changi Airport",
          " Transfer to Hotel",
          " Check in Hotel",
          " Evening free for leisure",
          " Overnight stay in Singapore",
        ],
      },
      {
        day: "02",
        title: "SINGAPORE CITY TOUR",
        details: [
          " Breakfast at the Hotel",
          " Guided Singapore City Tour",
          " Visit Merlion Park",
          " Drive past Suntec City & Fountain of Wealth",
          " Visit Chinatown",
          " Visit Little India",
          " Visit Orchard Road",
          " Afternoon free for shopping",
          " Overnight stay in Singapore",
        ],
      },
      {
        day: "03",
        title: "SENTOSA ISLAND TOUR",
        details: [
          " Breakfast at the Hotel",
          " Transfer to Sentosa Island",
          " One-way Cable Car Ride",
          " Visit Madame Tussauds",
          " Visit SEA Aquarium",
          " Visit Universal Studios Singapore",
          " Evening Wings of Time Show",
          " Return to Hotel",
          " Overnight stay in Singapore",
        ],
      },
      {
        day: "04",
        title: "GARDENS BY THE BAY & MARINA BAY",
        details: [
          " Breakfast at the Hotel",
          " Visit Gardens by the Bay (Flower Dome & Cloud Forest)",
          " Visit Marina Bay Sands SkyPark (Optional)",
          " Free time at Marina Bay area",
          " Evening Singapore River Cruise",
          " Overnight stay in Singapore",
        ],
      },
      {
        day: "05",
        title: "DEPART SINGAPORE",
        details: [
          " Breakfast at the Hotel",
          " Check out from Hotel",
          " Transfer to Changi Airport",
          " Departure with Memorable Experiences",
        ],
      },
    ],
    inclusions: [
      "Hotel Accommodation",
      "Daily Hotel Breakfast",
      "Airport transfers",
      "Singapore City Tour",
      "Sentosa Island Tour",
      "Gardens by the Bay entry",
      "Singapore River Cruise",
    ],
    exclusions: [
      "Travel Insurance",
      "All personal expenses",
      "Meals not mentioned in the itinerary",
      "5% GST and bank transfer charges",
    ],
  },

  // 8. Spain Tour
  {
    id: 11,
    title: "Vibrant Spain",
    subtitle: "Madrid – Barcelona – Seville",
    image: spain1,
    images: [spain1, spain2, spain3, spain4, spain5, spain6],
    overview: [
      [
        "Spain is a lively European destination known for its rich history, stunning architecture, passionate culture, and world-famous cuisine. From the royal heritage of Madrid to the artistic wonders of Barcelona and the traditional charm of Seville, Spain offers a perfect mix of culture, leisure, and vibrant city life. Flamenco music, historic monuments, beautiful plazas, and delicious tapas make every moment in Spain unforgettable.🇪🇸",
      ],
    ],
    duration: "6 Nights / 7 Days",
    itinerary: [
      {
        day: "01",
        title: "ARRIVAL IN MADRID",
        details: [
          "Arrived in Madrid, Spain",
          " Meet and Greet at the Airport",
          " Transfer to Hotel",
          " Check in Hotel",
          " Evening free for leisure",
          " Overnight stay in Madrid",
        ],
      },
      {
        day: "02",
        title: "MADRID CITY TOUR",
        details: [
          " Breakfast at the Hotel",
          " Guided Madrid City Tour",
          " Visit Royal Palace of Madrid",
          " Visit Puerta del Sol",
          " Visit Plaza Mayor",
          " Drive past Gran Via",
          " Visit Santiago Bernabéu Stadium (Outside view)",
          " Evening free for shopping",
          " Overnight stay in Madrid",
        ],
      },
      {
        day: "03",
        title: "MADRID – SEVILLE",
        details: [
          " Breakfast at the Hotel",
          " Check out from Hotel",
          " Transfer to Seville by train",
          "*Approx 2.5 hours journey*",
          " Arrival in Seville / Check in Hotel",
          " Evening free to explore local streets",
          " Overnight stay in Seville",
        ],
      },
      {
        day: "04",
        title: "SEVILLE CITY TOUR",
        details: [
          " Breakfast at the Hotel",
          " Guided Seville City Tour",
          " Visit Seville Cathedral & Giralda Tower",
          " Visit Alcázar of Seville",
          " Walk through Santa Cruz Quarter",
          " Evening Flamenco Show",
          " Overnight stay in Seville",
        ],
      },
      {
        day: "05",
        title: "SEVILLE – BARCELONA",
        details: [
          " Breakfast at the Hotel",
          " Check out from Hotel",
          " Transfer to Barcelona by flight / train",
          " Arrival in Barcelona / Check in Hotel",
          " Evening free at La Rambla",
          " Overnight stay in Barcelona",
        ],
      },
      {
        day: "06",
        title: "BARCELONA CITY TOUR",
        details: [
          " Breakfast at the Hotel",
          " Guided Barcelona City Tour",
          " Visit Sagrada Familia",
          " Visit Park Güell",
          " Drive past Casa Batlló & Casa Milà",
          " Visit Montjuïc Hill",
          " Evening free for leisure",
          " Overnight stay in Barcelona",
        ],
      },
      {
        day: "07",
        title: "DEPART BARCELONA",
        details: [
          " Breakfast at the Hotel",
          " Check out from Hotel",
          " Transfer to Barcelona Airport",
          " Departure with Wonderful Memories",
        ],
      },
    ],
    inclusions: [
      "Hotel Accommodation",
      "Daily Hotel Breakfast",
      "Airport transfers",
      "Intercity transfers by train / flight",
      "Guided city tours as per itinerary",
      "Entrance fees as per itinerary",
    ],
    exclusions: [
      "Travel Insurance",
      "All personal expenses",
      "Meals not mentioned in the itinerary",
      "5% GST and bank transfer charges",
    ],
  },

  // 9. Switzerland Tour
  {
    id: 9,
    title: "Elite Switzerland",
    subtitle: "Zurich - Lucerne - Interlaken- Jungfraujoch - Rhine Falls",
    image: swiss1,
    images: [swiss1, swiss2, swiss3, swiss4, swiss5],
    overview:
      "Switzerland is a picture-perfect destination known for its snow-capped Alps, crystal-clear lakes, and charming mountain villages. Enjoy scenic train journeys like the Glacier Express that offer breathtaking panoramic views. Explore iconic cities such as Zurich, Lucerne, and Interlaken blending culture, history, and modern lifestyle. Experience thrilling adventures with cable car rides, mountain excursions, and alpine sports. Indulge in world-famous Swiss chocolates, cheeses, and premium hospitality. A Switzerland tour promises luxury, romance, and unforgettable natural beauty at every turn. 🇨🇭",
    duration: "5 Days / 6 Nights",
    itinerary: [
      {
        day: "01",
        title: "INDIA - ZURICH STATION – LUCERNE HOTEL",
        details: [
          "Welcome to Lucerne – Switzerland! Later drive to Lucerne City, Upon arrival check In to hotel",
          "Later we visit the Town of Lucerne, to see the Chapel Bridge and the Lion Monument.",
          "Evening, enjoy a Cruise on the beautiful Lake Lucerne.",
          "Overnight stay at Hotel, Lucerne",
        ],
      },
      {
        day: "02",
        title: "MT. TITLIS EXCURSION WITH SWISS PASS",
        details: [
          "A memorable experience awaits you as you depart on an excursion to the glacier paradise of Mount Titlis.",
          "Ascend in the world's first revolving gondola ROTAIR, ride the spectacular ice flyer chairlift and see the ice grotto.",
          "Meal Plan – Breakfast",
        ],
      },
      {
        day: "03",
        title: "LUCERNE – INTERLAKEN",
        details: [
          "Transfer from Lucerne to Interlaken and free day at leisure.",
          "Free day to explore the city on your own with a Swiss pass.",
          "Meal Plan – Breakfast",
        ],
      },
      {
        day: "04",
        title: "INTERLAKEN – JUNGFRAUJOCH",
        details: [
          "Depart on an excursion from Interlaken to Jungfraujoch- Top of Europe.",
          "This memorable train trip from Interlaken Ost takes you via Lauterbrunnen and Wengen to the Kleine Scheidegg, at the foot of the famous Eiger North Wall.",
          "Then ascend by the Jungfrau Railway to the magnificent mountain world of eternal ice and snow, Jungfraujoch-at 3454mts, the highest railway station in Europe.",
          "Visit the Ice Palace and Sphinx Terraces offering breathtaking views of the Aletsch Glacier, the longest glacier in the Alps.",
          "Overnight in Hotel.",
          "Meal Plan – Breakfast",
        ],
      },
      {
        day: "05",
        title: "INTERLAKEN – ZURICH",
        details: [
          "After breakfast, transfer from Interlaken to Zurich.",
          "Visit legendary landmarks like the sophisticated Bahnhofstrasse.",
          "Admire the shimmering surface of Lake Zurich.",
          "Visit the sacred St Peter’s Church and the charming Old Town.",
          "A visit to the Chocolate Lindt Shop!",
          "Meal Plan – Breakfast",
        ],
      },
      {
        day: "06",
        title: "RHINE FALLS FROM ZURICH",
        details: [
          "Breakfast at Hotel",
          "Today, Morning we proceed to Marvel at the Rhine Falls, Europe's biggest waterfall, on this half-day tour from Lucerne.",
          "Travel to Northern Switzerland, a beautiful wine growing region with charming farming villages and scenic landscape near the German border.",
          "Enjoy a full hour to admire and capture photos of the powerful falls, and in summer, take a thrilling boat ride to get a closer look at them.",
          "On arrival in Lucerne, Check in to hotel.",
          "Overnight stay at Hotel, Zurich.",
          "Meal Plan – Breakfast",
        ],
      },
      {
        day: "07",
        title: "DEPARTURE TO INDIA",
        details: [
          "Early Breakfast at Hotel",
          "Check out and proceed to Zurich Airport for your departure flight",
          "Tour Ends",
          "Meal Plan – Breakfast",
        ],
      },
    ],
    inclusions: [
      "02 Night Stay in Zurich",
      "02 Night Stay in Lucerne",
      "02 Night Stay in Interlaken",
      "Meals on Breakfast",
      "All the Tours and Transfers as per the Itinerary",
      "All tips, road tolls, and taxes at the destination included",
      "International Air Tickets",
      "Mount Titlis entry ticket",
      "Jungfraujoch entry ticket",
      "Lindt Chocolate Factory",
      "Rhine Falls day trip from Zurich",
      "One time Visa Charges (Schengen)",
      "Overseas Travel Insurance",
      "Applicable GST",
    ],
    exclusions: [
      "City Tax payable at the time of check-out.",
      "Meals, Tips, Laundry, telephone, optional excursions and other items of a personal nature.",
      "Cost of foreign exchange for personal use.",
      "Any items or services not specified in the itinerary 'PACKAGE INCLUDES' head.",
    ],
  },
];

export default international;
